app:
  name: Financiamentos
  next: Próximo
  create_new_simulation: Analisar crédito
  previous: Anterior
  advance: Avançar
  advance_and_update: Atualizar e avançar
  share: Compartilhar
  whatsapp: WhatsApp
  back: Voltar
  send: Enviar
  check_payment_mode_information: Verificar informações
  confirm: Confirmar
  send_for_analysis: Enviar para análise
  send_data: Enviar dados
  send_biometry: Enviar Biometria
  save: Salvar
  save_equipments: Salvar equipamentos
  save_equipment_changes: Salvar alterações
  cancel: Cancelar
  edit_equipment: Alterar
  cancel_equipment_edit: Cancelar alteração
  cancel_analysis: Cancelar análise
  backList: Voltar para a listagem
  alert:
    partner:
      title: 'Visualizando projetos como: | Visualizando projeto como: '
      statement_title: 'Visualizando extrato como:'
      description: >-
        Aqui você encontra os projetos do parceiro acima. Para ver todos os
        projetos clique no botão ao lado.| Para voltar a visualização de admin,
        clique no botão ao lado.
      statement_description: Aqui você encontra as últimas transferências do parceiro acima.
      textButton: Voltar ao modo administrador
      textButtonMobile: Voltar ao admin
      viewing_as: Visualizando como
    temporary_instability:
      title: Instabilidade temporária
      description: Nossas plataformas podem apresentar lentidão ou falhas devido a uma instabilidade. Estamos acompanhando a situação.
resumeWidget:
  simulationSummary: Resumo da simulação
  summary: Resumo
  close: Fechar
  gracePeriod: Carência
  insurance: Seguros
  combo: Combo Fácil
  ampera: Ampera
  month: Mês | Meses
  financedValue: Valor Financiado
  downPayment: Entrada
  totalProjectValue: Valor total do projeto
  cet: |-
    CET |
    CET black
  interestRate: Taxa de juros
  installment: Parcela
  financing: Financiamento
  interestRateTooltip: |
    A taxa de juros pode sofrer
    alterações de acordo com as
    condições selecionadas
    na proposta
  cetTooltip: |
    O Custo Efetivo Total (CET) pode
    sofrer alterações de acordo
    com o IOF diário
  opportunities:
    title: Seus ganhos
    commission: Comissão
    insuranceCommission: Comissão do Seguro
  editSimulation: Editar Simulação
  viewSimulation: Visualizar Simulação
header:
  welcome: Bem-vindo
  exit: Sair
  project:
    title: Financiamento
    power: Potência
    capacity: Capacidade
    system: Sistema
    system_types:
      without_battery: Completo
      with_battery: Completo com bateria
      only_battery: Somente bateria
    combo: Combo Fácil
    combo_connect: Combo Conecte
    admin: Administrador
    int_light: Integrador Light
    expired: Expirado
    turbo:
      tag: Projeto turbo
      alert:
        title_before: Este
        title_emphasis: projeto específico
        title_after: é turbo
        description: >-
          Análise de documentação simplificada: menos requisitos e aprovação mais direta.
          Aproveite para seguir com a formalização.
    only_battery:
      alert:
        title: 'Atenção: compatibilidade entre inversor e bateria'
        description: >-
          A compatibilidade entre o inversor e a bateria escolhidos é de responsabilidade do parceiro.
          Modelos diferentes, mesmo de um mesmo fabricante, podem não ser compatíveis entre si.
          Confira sempre o datasheet e, em caso de dúvida, consulte o fabricante antes de fechar o projeto.
    steps:
      new: Nova simulação
      result: Resultado
      details: Parcelas
      simulation: Simulação
      formalization: Proposta
      installation: Instalação
      contraction: Contratação
  bnpl:
    steps:
      simulation: Simulação
      formalization: Proposta
      external: Externo
    status:
      IN_PROGRESS:
        type: warning
        text: Em andamento
      EXPIRED:
        type: neutral
        text: Expirado
      DONE:
        type: positive
        text: Concluído
  impersonate:
    modal:
      title: Visualizar como parceiro
      subtitle: Busque pelo Nome ou CNPJ do parceiro que deseja visualizar
      input_label: Nome do parceiro ou CNPJ
      button: Visualizar
      empty_state:
        title: Nenhum parceiro encontrado
        description: >-
          Não foi possível encontrar o parceiro que você está buscando.
          Verifique se o nome ou CNPJ está correto e tente novamente.
    error:
      title: Erro ao visualizar como parceiro
      description: >-
        Não foi possível visualizar como parceiro. Verifique se o parceiro foi
        selecionado e tente novamente.
  simulation:
    status:
      reproved:
        text: Reprovado
      approved:
        text: Aprovado
  search:
    placeholder: Nome, CPF/CNPJ ou ID do projeto
    loading:
      title: Carregando resultados
      text: Buscando projetos...
    empty:
      type_to_search: Digite para buscar
      press_enter: Pressione Enter para buscar
      no_results: Nenhum resultado encontrado
    labels:
      project_name: Nome do projeto
      id: ID
      step: Etapa
      more_projects: Mais Projetos
    project_fallback: Projeto
    status:
      approved: Aprovada
      in_progress: Em andamento
      under_analysis: Em análise
      reproved: Reprovado
      expired: Expirado
      canceled: Cancelada
      to_review: Revisar
      waiting_customer: Aguardando cliente
    step:
      simulation: Simulação
      equipment: Equipamentos
      customer_data: Dados do cliente
      biometry_and_contract: Biometria e contrato
      payment_model: Modelo de recebimento
      installation: Instalação
home:
  title: Projetos
  subtitle: Todos os seus projetos em um só lugar
  newSimulation: Nova simulação
  banner:
    title: Nova plataforma de formalização!
    subtitle: Após concluir a simulação, formalize mais rápido nessa nova experiência
overview:
  title: Visão geral
  intro_modal:
    title: Novidades no Portal de Financiamentos
    description: Temos uma <strong>nova experiência</strong>, desenhada para que você gaste menos tempo procurando informações e mais tempo fechando negócios
    description_2: Confira todas as novidades e, em seguida, conta pra gente o que achou quando receber nossa pesquisa de satisfação.
    bullets:
      navigation: <strong>Navegação aprimorada</strong> e <strong>mais espaço</strong> para a gestão dos seus projetos.
      search: <strong>Busca de projetos</strong> sempre à mão.
      projects_panel: <strong>Nova tela Visão Geral</strong>, com painel de projetos em andamento e links para ir direto à listagem filtrada.
      metrics: Em Visão Geral, melhor visibilidade do seu <strong>modelo de recebimento</strong> e da <strong>saúde da sua carteira</strong> de clientes.
      projects_in_progress: Navegação aprimorada e mais espaço para a gestão dos seus projetos;
      sales_funnel: Busca de projetos sempre à mão;
      click_to_filter: Painel de projetos em andamento, com acesso facilitado aos projetos em cada status;
      wallet_health: Melhor visibilidade da saúde da sua carteira de clientes.
      payment_model: Melhor visibilidade do seu modelo de recebimento.
    actions:
      start_tour: Confira como ficou
      view_all: Ver todas as novidades
      view_this_screen: Ver novidades desta tela
      skip_tour: Pular apresentação
  projects_in_progress:
    title: Projetos em andamento
    view_all: Ver todos
    total: Total
    status:
      in_progress: Em andamento
      to_retrieve: A repescar
    categories:
      simulations: Simulações
      proposals: Propostas
      installations: Instalações
    breakdowns:
      approved_simulations: Simulações aprovadas
      reassessments: Repescagens
      equipment: Equipamentos
      customer_data: Dados do cliente
      biometry_and_contract: Biometria e contrato
      payment_model: Modelo de recebimento
      installations_in_progress: Instalações em andamento
    mobile_labels:
      approved: Aprovadas
      in_progress: Em andamento
      data: Dados
      biometry: Biometria
      model: Modelo
    last_updated:
      updating: Atualizando...
      error: Erro ao carregar dados
      now: Atualizado há agora
      less_than_minute: Atualizado há menos de um minuto
      minutes: Atualizado há {count} minuto | Atualizado há {count} minutos
      hours: Atualizado há {count} hora | Atualizado há {count} horas
      days: Atualizado há {count} dia | Atualizado há {count} dias
    empty:
      title: Comece um novo projeto
      subtitle_line1: Você ainda não possui projetos.
      subtitle_line2: Faça uma simulação e aproveite as vantagens de financiar com a Solfácil.
      new_simulation: Nova simulação
    not_impersonate:
      title: Visualize os projetos de um parceiro
      subtitle: Para consultar projetos, selecione a empresa para entrar no modo de visualização como parceiro.
      view_as_partner: Visualizar com parceiro
  notifications:
    title: Notificações
    empty:
      title: Fique ligado no sininho
      subtitle: Aqui você acompanha avisos e novidades sobre seus financiamentos e projetos.
  wallet_health:
    title: Saúde da sua Carteira
    download_button: Lista de clientes
    image_alt: Ilustração da saúde da carteira
    intro:
      description1_prefix: 'Ter uma carteira de '
      description1_highlight1: clientes que pagam em dia
      description1_middle: ' seus financiamentos contribui para que você aproveite mais '
      description1_highlight2: benefícios e oportunidades
      description1_suffix: ' ao financiar com a Solfácil.'
      description2: Acompanhe periodicamente a sua carteira.
    arrears:
      title: Clientes em atraso
      description: Consulte a lista de clientes que atualmente possuem parcelas do financiamento em atraso.
      button: Baixar lista (.csv)
    descriptions:
      bom:
        title: Parabéns! Seus indicadores estão saudáveis.
        subtitle: Você já tem a melhor parcela para o seu nível.
      regular: Melhore as suas taxas ajustando as parcelas em aberto de alguns dos seus clientes.
      ruim: Você possui diversos clientes que não estão pagando as parcelas. Ajuste seus índices de inadimplência para melhorar as taxas que você oferece aos seus clientes.
      na: Você ainda não possui informações de saúde da sua carteira de clientes no último ano.
      full: Parabéns, você não possui nenhum cliente com parcelas pendentes.
    info:
      full:
        title: Você não possui nenhum cliente com parcelas pendentes.
      improve:
        title: 'Como manter a sua carteira saudável:'
        tip1: Verifique se houve algum problema na instalação.
        tip2: Verifique se o projeto está gerando a economia esperada.
        tip3: Entre em contato com seus clientes e entenda o porquê da inadimplência.
        tip4: Confira a conectividade dos Amperas instalados
    how_works:
      title: Como funciona?
      description1: Com Solfácil Mais, quanto mais alto o seu nível, melhor serão as parcelas que você pode ofertar para seus clientes no financiamento.
      description2: Além do seu nível no programa, nós também acompanhamos o índice de inadimplência da sua carteira de clientes. Quanto maior o seu nível e mais adimplentes seus clientes, ainda melhores serão as suas parcelas!
    not_impersonate:
      title: Visualize a saúde da carteira de um parceiro
      description: Para fazer isso, entre no modo de visualização como parceiro.
      button: Visualizar com parceiro
  payment_model:
    title: Modelo de recebimento
    not_impersonate:
      title: Consulte o modelo de recebimento de um parceiro
      description: Para fazer isso, entre no modo de visualização como parceiro.
      button: Visualizar com parceiro
  banner:
    dispara_solfacil_alt: Banner campanha Dispara Solfácil — R$ 50 mil em cartão pré-pago
    boleto_em_dia_alt: Banner Boleto em Dia, Sorte na Mão
    golaco_solfacil_alt: Banner Golaco Solfácil
  news:
    title: Mais vantagens para você e seus clientes
    combo_conecte:
      title: Combo Conecte
      description:
        prefix: Escolha o
        highlight: Combo Conecte
        suffix: e garanta maior aprovação de financiamentos e mais vantagens.
      button_text: Ver Combo Conecte
    combo_facil:
      title: Combo Fácil
      description:
        prefix: Com o
        highlight: Combo Fácil
        suffix: você aproveita as ofertas da loja Solfácil e conta com mais vantagens ao financiar.
      button_text: Ver Combo Fácil
    seguros:
      title: Seguros
      description:
        prefix: Seguros para
        highlight: Riscos Diversos
        middle: e
        highlight2: Contra Perda de Renda
        suffix: Proteção completa para o seu cliente.
      button_text: Ver Seguros
simulation:
  next: Ver parcelas
  load_again: Carregar novamente
  founded: Simulações encontradas
  golist: Ir para a lista
  list: Simulações
  subtitles: Acesse suas simulações salvas
  new: Simulação
  return_formalization: Ir para proposta
  project_type: Linhas de financiamento
  cpf_use_terms:
    client: Eu, na qualidade de Integrador, declaro e garanto que obtive autorização prévia, expressa e inequívoca do Cliente (e do Devedor Solidário, se aplicável) para o tratamento de seus dados pessoais, pesquisas de mercado e análises estatísticas, em estrita conformidade com o
    terms: Termo de Uso
    with: ', com o'
    terms_authorization: Termo de Autorização de Consulta
    and_with: e com a
    privacy_policy: Política de Privacidade da Solfácil
  continue_with_value: Seguir com valor aprovado
  financing_options: Opções de financiamento
  suppliers_modal:
    title: Distribuidoras autorizadas e regras
    button_ok: Entendi
    intro: 'Na Solfácil, você pode financiar kits solares comprados em nossa própria loja ou em outras distribuidoras autorizadas, sejam elas parceiras da Solfácil ou não. Confira as regras para cada tipo de distribuidora:'
    search_placeholder: Buscar fornecedor
    list_partners_title: Lista de parceiras
    list_others_title: Demais autorizadas
    tabs_partners: Distribuidoras parceiras
    tabs_non_partners: Demais distribuidoras autorizadas
    partners_heading_0: Seu pedido do kit é verificado;
    partners_heading_1: A Solfácil faz o pagamento do kit diretamente à distribuidora parceira.
    partners_benefit: Isso evita que você comprometa o seu fluxo de caixa com a compra do kit. Nós verificamos o seu pedido e cuidamos do pagamento à distribuidora.
    non_partners_heading_0: Você mesmo faz o pagamento do kit na distribuidora escolhida
    non_partners_heading_1: Você nos envia a nota fiscal para reembolso do valor pago, após análise.
    non_partners_benefit: Nesse caso, você perde a praticidade oferecida pelas distribuidoras parceiras da Solfácil, mas nossa plataforma também está preparada para te atender.
    how_it_works: 'Veja como funciona:'
    partners_step_0_prefix: 'Você informa a '
    partners_step_0_bold: distribuidora, o e-mail de contato dela e o valor do kit
    partners_step_0_suffix: ;
    partners_step_1_prefix: 'Nós enviamos a '
    partners_step_1_bold: carta de faturamento
    partners_step_1_suffix: ' para eles;'
    partners_step_2_prefix: 'Eles te enviam a '
    partners_step_2_bold: 'Nota Fiscal do Kit a ser adquirido '
    partners_step_2_suffix: para o financiamento;
    partners_step_3_prefix: ''
    partners_step_3_bold: 'Você anexa a Nota Fiscal '
    partners_step_3_suffix: e envia para nossa análise.
    partners_step_4_prefix: 'Com tudo ok, '
    partners_step_4_bold: a Solfácil paga o kit diretamente para a distribuidora parceira
    partners_step_4_suffix: .
    non_partners_step_0_prefix: ''
    non_partners_step_0_bold: Você faz o pedido e o pagamento do kit
    non_partners_step_0_suffix: ' na distribuidora escolhida;'
    non_partners_step_1_prefix: 'Você anexa a '
    non_partners_step_1_bold: Nota Fiscal de Remessa
    non_partners_step_1_suffix: ' e envia para nossa análise.'
    non_partners_step_2_prefix: 'Com tudo ok, a '
    non_partners_step_2_bold: Solfácil transfere para a sua conta o valor do kit financiado
    non_partners_step_2_suffix: ' e demais recebíveis conforme o seu modelo de recebimento.'
    empty_title: Nenhum fornecedor encontrado
    empty_subtitle: Não há fornecedores nesta lista no momento.
    link_installment_card: Ver distribuidoras autorizadas e regras de recebimento
  details:
    info_title: Dados da simulação somente para visualização.
    info_description: Após a assinatura do contrato não será mais possível editar a simulação.
  conclude: Concluir simulação
  info_risk:
    RS_title: O cliente foi aprovado na simulação
    RS_description_conditions: 'Fique atento às condições:'
    RS_description_grace: Carência obrigatória de 6 meses.
    RS_description_eligible_area: >-
      Localização em área elegível. A Solfácil sabe o quanto é importante estar
      presente em todas as regiões e está comprometida a fazer isso de um jeito
      eficiente e responsável.
    necessary_install_pending_project_title: >-
      Você possui instalações pendentes. Conclua suas instalações pendentes para
      formalizar este projeto.
    necessary_install_pending_project_description: >-
      Para formalizar este financiamento é necessário concluir suas instalações
      pendentes.
  modal:
    title: Nova plataforma de proposta!
    altImg: Tela de financiamento
    info:
      proposal:
        title: Mande sua proposta em até 2 minutos!
        description: Preencha tudo de uma vez e aguarde nossa análise.
      projects:
        title: Faça seus projetos quando e onde quiser!
        description: 'Celular, computador ou tablet: você escolhe como e onde.'
      payments:
        title: Pagamentos em tempo real
        description: Após aprovação, pagamentos 24h por dia, 7 dias na semana.
    button:
      old: Seguir com a plataforma antiga
      new: Seguir com a nova plataforma!
  bannerComboFacil:
    title: Kit da Loja + Financiamento = Combo Fácil
    description: Condições e benefícios exclusivos para você e seu cliente
  solfacil_smart:
    title: Monitoramento Solfácil Smart
    tag: Novidade
    subtitle: Transforme dados em novas vendas e fortaleça o relacionamento com seus clientes.
    feature1:
      bold: Antecipe falhas
      text: e ofereça serviços adicionais
    feature2:
      text: Tenha uma
      bold: fonte de receita mensal
      text2: com o modelo de assinatura
    feature3:
      bold: Seu cliente vê valor
      text: todos os dias e entende a economia real
    button:
      know: Conheça
      buy: Comprar na loja
    image_alt: Ilustração do Monitoramento Solfácil Smart
    form:
      title: Este projeto terá o monitoramento Solfácil Smart?
      subtitle: Marque esta opção se você incluiu nosso sistema de monitoramento no kit do projeto.
      yes: Sim
      no: Não
      store_link: Ver Solfácil Smart na loja
      warning: Certifique-se de ter incluído o Solfácil Smart no pedido do kit na loja.
  result:
    data:
      title: Dados da simulação
      name: Nome do projeto
      type:
        cpf: CPF
        cnpj: CNPJ
      client: do cliente
      value: Valor total do projeto
      bill: Conta de luz
      systemPower: Potência (kWp)
      batteryCapacity: Capacidade da bateria (kWh)
      down_payment: Entrada
      system_type: Tipo sistema
    financing:
      title: Financiamento
      subtitle: Prazos e parcelamento flexíveis para o seu cliente
      pre_approved_value: Valor pré-aprovado
      max_installments: Prazo pré-aprovado
      to: até
      of: de
      with_interest: Com juros
      max_grace_period: Carência pré-aprovada
      months: meses
      down_payment: Entrada (para você)
      project_value: Valor financiado solicitado
      kit: Aquisição Kit
      store: Loja Solfácil ou externo
      requested_value: Valor solicitado
      installment_value: Valor da parcela
      combo_easy_text: Condições especiais com combo fácil
      combo_connect_text: Condições especiais com combo conecte
      combo_conecte_only_text: Exclusividade Combo Conecte
      combo_conecte_only:
        button_text: Financiar com Combo Conecte
        know_more: Entenda o Combo Conecte
        consult_inverters:
          prefix: '*Consulte os '
          link_text: inversores compatíveis
          suffix: ' com o Combo Conecte'
    modals:
      combo_connect:
        title: Financiamento com Combo Conecte
        button_ok: Entendi
        tabs:
          benefits: Vantagens e regras
          inverters: Inversores compatíveis
        benefits:
          description: >-
            Financiando e comprando um kit com a Solfácil, seu cliente paga
            menos e você vende mais. Com o Combo Conecte você conta com vantagens como:
          title: Vantagens do Combo Conecte
          items:
            one: Aprovação de crédito facilitada
            two: Maiores margens na transação
            three: Preços competitivos na Loja Solfácil
            four: Parcelas mais baixas para o seu cliente
            five: Mais pontos no Solfácil Mais
        important:
          title: 'É importante saber que:'
          items:
            one:
              text: O Combo Conecte requer a compra de
              highlight: inversores compatíveis.
            two:
              text: O local da instalação deve possuir
              highlight: internet wi-fi disponível para conexão com o inversor.
            three:
              text_before: Os inversores na modalidade Combo Conecte permitem a
              highlight: gestão remota da geração
              text_after: ', de acordo com as regras do financiamento ou em caso de desconexão prolongada do wi-fi.'
        inverters:
          description: >-
            Confira os inversores compatíveis com o Combo Conecte e consulte a disponibilidade na Loja Solfácil.
          store_button: Ir para a Loja
          alert:
            description: >-
              Microinversores não estão disponíveis no Combo Conecte.
          list:
            brand: Marca
            name: Modelo
            power: Potência
          power: Potência
          empty:
            title: Nenhum inversor encontrado
            subtitle: Não encontramos inversores compatíveis com o Combo Conecte para este projeto.
    bnpl:
      banner:
        title: Conheça o | A nova opção de pagamento para seus projetos
        emphasis: Parcelado Solfácil
        description: >-
          Compre o Kit na Loja Solfácil, e receba seu serviço à vista. Seu
          cliente paga em até 9x, e em condição promocional de lançamento, em
          até 3x, não há taxas e tarifas
      title: Parcelado Solfácil
      subtitle: Parcelamento sem comprometer o crédito do cartão do seu cliente
      subtitleTwo: >-
        Estamos trabalhando em uma nova opção de pagamento para você e seu
        cliente que em breve você vai poder contar!
      new: Novidade!
      will_be_pre_approved: Confira as condições que seriam pré-aprovadas
      pre_approved_value: Valor pré-aprovado
      approved_with_restrictions: Aprovado, com restrições
      max_installments: Parcelado em até
      to: até
      max_grace_period: Carência pré-aprovada
      without_interest: Sem juros
      without_period: Sem carência
      down_payment: Entrada (cliente para Solfácil)
      of: de
      project_value: Parcelas de até
      kit: Aquisição Kit
      store: Loja Solfácil
      customerRejected:
        title: Cliente reprovado
        description:
          title: Existem duas ações que você pode tomar
          actions:
            - >-
              1. Consulte os órgãos de proteção ao crédito e veja se esse CPF ou
              CNPJ está regular.
            - >-
              2. Consulte este CPF ou CNPJ novamente daqui 30 dias. Esse prazo é
              necessário porque pode ser que ocorram alterações nas situações
              dos mesmos.
        altImg: Imagem representando o cliente sendo reprovado
        onlyBatteryLimit:
          title: Financiamento de bateria indisponível no momento
          description: >-
            Não é possível seguir com o financiamento apenas de bateria para
            este projeto agora. Novas simulações ficarão disponíveis a partir do
            próximo mês.
      customerRejectedGuarantor:
        title: Cliente reprovado
        description:
          title: Existem duas ações que você pode tomar
          actions:
            - >-
              1. Consulte os órgãos de proteção de crédito e veja se este CPF ou
              CNPJ está regular.
            - 2. Refaça a análise e adicione outro avalista.
      alerts:
        responsibility:
          title: Atenção!
          description: >-
            Sabe o cliente que, mesmo sem crédito, você parcela, assumindo o
            risco? Aqui é  semelhante, confira condições.
          action: Saiba mais
        restrictions:
          title: Cliente pré-aprovado com restrições
          description: >-
            Para esse cliente, temos duas opções para seguir com o
            financiamento. Selecione no quadro abaixo.
      shortly:
        title: Parcelado Solfácil
        flag: Em breve
        altImg: Calendário de Período de pagamento
        description: >-
          Em breve uma nova maneira de viabilizar seus projetos junto à Solfácil
          com o parcelado. Clique abaixo para registrar seu interesse e conheça
          às condições.
        textButton: Tenho interesse
      messages:
        noResults:
          title: Ops, algo deu errado
          description: >-
            Ocorreu algum problema e não conseguimos trazer o resultado da sua
            simulação. Tente novamente mais tarde
          textButton: Tente novamente
        analyzingSimulation:
          title: Analisando sua simulação
          description: >-
            Em breve vamos concluir a análise e você será notificado via e-mail.
            Você também pode acompanhar o status dela na listagem de simulações.
          textListButton: Ir para a lista
          textNewSimulationButton: Nova simulação
      modals:
        important:
          title: Importante!
          description: >-
            Você será responsabilizado caso o cliente fique inadimplente. A
            Solfácil poderá solicitar que você pague integralmente os valores do
            parcelamento, bem como poderá inserir os dados da sua empresa nos
            Órgãos de Proteção ao Crédito.
          textButton: Fechar
        attention:
          title: Atenção!
          description: >-
            Você será responsabilizado caso o cliente fique inadimplente. A
            Solfácil poderá solicitar que você pague integralmente os valores do
            parcelamento, bem como poderá inserir os dados da sua empresa nos
            Órgãos de Proteção ao Crédito.
          textCheckbox: Estou ciente
          textCancelButton: Cancelar
        interest:
          title: Como funciona o parcelado Solfácil?
          altImgOption1: Imagem representando as melhores condições
          option1: As melhores condições
          altImgOption2: Imagem representando parcelado Solfácil
          option2: De 3 à 9 vezes!
          altImgOption3: Imagem representando kits adquiridos pela Loja Solfácil
          option3: Kits adquiridos pela Loja Solfácil
          description: >-
            Comprando o kit na Loja Solfácil, você tem mais essa opção para
            fechar negócio!
          textButton: Fechar
      buttons:
        textFollowFinancing: Seguir financiamento
        textFollowInstallment: Seguir parcelamento
        textInterest: Tenho interesse
  bnpl:
    solfacilInstallment: Parcelado Solfácil
    identity: id
    installment_title: Parcela | Parcelas
    conditions_installment: >-
      Confira nossas opções a que melhor se encaixa no perfil do seu cliente. É
      possível simular o valor do kit do projeto, e defini-lo na etapa seguinte,
      de proposta.
    project_value: Valor do projeto
    due_date: Vencimento
    invoice_due_date: Vencimento da fatura
    kit_value: Valor do kit
    kit_value_helper: Atualizado após a seleção do kit
    number_order: N° do pedido
    service_value: Valor do serviço
    service_value_helper: Valor do projeto menos kit e taxa
    installment_amount: Valor da parcela
    initial_amount: Entrada
    receive_amount: Receberá
    installments:
      customer_pays:
        title: Parcela com o *serviço fixo*
        description: >-
          Você repassa o valor da taxa para seu cliente, aumentando o valor do
          projeto.
      customer_not_pays:
        title: Parcela com o *projeto fixo*
        description: Você arca com o valor da taxa, mantendo o valor do projeto.
    banner:
      title: Projetos parcelados
      description: >-
        Encontre seus projetos em andamento do nosso novo modelo de pagamento
        clicando no botão ao lado.
      tooltip: >-
        Agora além de financiamento, você pode ofertar ao seu cliente a nova
        linha "Parcelado Solfácil". Essa opção pode estar disponível na tela de
        "Resultado da simulação".
      button: Ver projetos
      black:
        title: Novo Crédito "Parcelado Solfácil"
        description: Até 9 parcelas, com condições exclusivas!
        textButton: Saiba mais
    modal:
      title: 'Novidade: Parcelado Solfácil'
      altImgOption1: Imagem representando as melhores condições
      option1: As melhores condições
      altImgOption2: Imagem representando parcelado Solfácil
      option2: De 3 à 9 vezes!
      altImgOption3: Imagem representando kits adquiridos pela Loja Solfácil
      option3: Kits adquiridos pela Loja Solfácil
      description: >-
        Parcelado Solfácil é a nova condição de pagamentos que a Solfácil
        oferece para você e seus clientes. Comprando o Kit na Loja Solfácil,
        você tem mais essa opção para fechar negócio! Disponível no resultado da
        simulação.
      textButton: Fechar
    id:
      summary:
        title:
          summary: Resumo
          service: Serviço fixo
        installment:
          title: Parcela
          prohibited: Entrada
          cet: CET
          am: a.m.
        enterprise:
          title: Para sua empresa
          total: Valor total do projeto
          kit: Kit da Loja
          tax: Taxa de antecipação
          value: Valor a receber
        client:
          title: Para seu cliente
          total: Valor total do projeto
          prohibited: Entrada
          installments: Parcelas
          of: de
  notFound:
    title: Nenhuma simulação encontrada
    subtitle: >-
      Busque por outro Nome, CPF, ou CNPJ para encontrar a simulação que está
      buscando. Caso esteja correto, faça uma nova simulação, clicando no botão
      abaixo.
  errorProject:
    title: Erro ao carregar a lista
    subtitle: >-
      Infelizmente não conseguimos exibir a sua lista de simulações nesse
      momento. O que deseja fazer?
  status_filter:
    done: Aprovado
    pending: Em processamento
    reproved: Reprovado
  ampera:
    description: Otimize seu pós-venda com o monitoramento e tenha desconto nas parcelas.
    textLink: Mais detalhes
    lack_of_stock:
      text1: >-
        Por se tratar de um segundo financiamento, não é necessário um novo
        Ampera para esta instalação.
      text2: >-
        O dispositivo Ampera não está mais disponível, mas fique tranquilo: sua
        parcela já conta com o melhor valor + desconto!
  newPage:
    title: Tipo de cliente
    description: Defina o perfil do seu cliente para esse projeto
    empty:
      title: Erro ao carregar tipos de financiamentos
      subtitle: >-
        Ocorreu um erro ao tentar carregar os tipos de financiamentos(PF e PJ).
        Tente novamente mais tarde.
    pf:
      title: Pessoa Física (PF)
      description: Linha de crédito para residências
      financing:
        title: Financiamento de até {value}
        description: Em até {maxFinancingInstallments} parcelas - Seguros - {period}
    pj:
      title: Pessoa Jurídica (PJ)
      description: Linha de crédito para empresas
      financing:
        title: Financiamento de até {value}
        description: Em até {maxFinancingInstallments} parcelas - {period}
    client_data:
      title: Dados do projeto
      description: Condições especiais de crédito para o seu cliente em poucos segundos.
      form:
        document_pf:
          title: CPF do cliente*
        document_pj:
          title: CNPJ do cliente*
          majoritary:
            title: CPF do sócio majoritário*
        value:
          title: Valor total do projeto
          placeholder: Digite o valor do projeto
        down_payment:
          title: Entrada
          placeholder: Digite o valor da entrada
        bill_value:
          old_title: Valor da conta de luz atual*
          title: Valor atual da conta de luz de todas as unidades consumidoras*
          placeholder: Digite o valor da conta
          helperText: O valor será validado mediante o envio das faturas das unidades consumidoras
          old_helper_text: O valor inserido precisa ser igual à fatura de energia
          title_modal: Como funcionam as múltiplas contas de luz?
          description_modal: 'O projeto pode ser composto por mais de uma unidade consumidora a ser beneficiada pelo sistema fotovoltaico, desde que atenda às seguintes regras:'
          description_modal_item1: As contas precisam ser todas da mesma concessionária de energia;
          description_modal_item2: É necessário comprovar vínculo familiar entre os titulares da conta de luz e o cliente final;
          description_modal_item3: A data de emissão da conta de luz pode ter no máximo 3 meses;
          description_modal_item4: O valor de conta de luz a ser preenchido na Simulação deve ser o consumo total atual das unidades consumidoras.
        power:
          title: Potência do sistema*
          placeholder: Digite o valor da potência
          system_power_error_422: Diminua o valor do projeto ou aumente a potência para continuar
          battery_capacity_title: Capacidade da bateria*
          battery_capacity_placeholder: Digite o valor da capacidade
          battery_capacity_range_error: A capacidade da bateria deve estar entre 1 kWh e 999 kWh
          battery_capacity_error_422: Diminua o valor do projeto ou aumente a capacidade da bateria para continuar
        error:
          title: Ocorreu um erro ao tentar criar o projeto.
    form:
      system_type:
        label: Tipo de sistema
        placeholder: Selecione o tipo de sistema
        with_battery: Com bateria
        without_battery: Sem bateria
        only_battery: Somente bateria
revision:
  title: Revisão da simulação
  subtitle: >-
    Revise e altere todos os dados da simulação, inclusive valores, desde que
    estejam dentro das nossas políticas.
  subtitle_complement: Caso contrário, será necessário realizar uma nova simulação.
buttons:
  back: Voltar
  discart: Descartar alteração
  edit_save: Salvar edição
  go_financing: Ir para financiamentos
  go_new_page: Refazer análise
loading:
  messages: >-
    Estamos quase lá, Captando energia solar para alimentar nossos cálculos, Os
    raios solares estão chegando, Carregando com a força do sol
list:
  days: '- | {count} dia | {count} dias'
installments:
  banner:
    start: Ganhe
    middle: 10% de desconto
    end: no valor dos produtos do kit, seguindo com uma das parcelas Combo.
    title: 'Combo Fácil:'
    link:
      text: Comprar agora
  banner_combo_offer:
    start: Oferta especial para você!
    middle1: Ganhe
    middle2: 10% de desconto
    end: no valor dos produtos do kit ao escolher uma das parcelas Combo.
  with_combo: Parcelas com Combo Fácil
  with_combo_description: Parcela barata para o seu cliente. Kit deve ser comprado na Loja Solfácil
  with_combo_comission: Parcelas com Combo Fácil e comissão
  with_combo_comission_description: >-
    Melhor custo benefício para você e seu cliente. Kit deve ser comprado na
    Loja Solfácil.
  with_combo_conecte: Parcelas com Combo Conecte
  with_combo_conecte_description: >-
    Melhor parcela para o seu cliente, com o inversor conectado ao Wi-fi. Kit deve ser comprado na loja Solfácil.
  combo_conecte_label: Combo Conecte
  combo_facil_label: Combo Fácil
  novelty_label: Novidade
  combo_conecte_tooltip: O Combo Conecte requer a conexão contínua dos inversores à internet, possibilitando que a Solfácil ofereça condições de financiamento ainda mais vantajosas. Nesse modelo, em caso de inadimplência ou de desconexão da internet, o inversor é desligado. Confira os modelos compatíveis na etapa de equipamentos.
  ampera_label: Ampera
  insurance_label: Seguro
  standard_label: Padrão
  without_combo: Parcelas sem Combo Fácil
  without_combo_description: >-
    Opção mais cara para seu o cliente. Kit pode ser comprado fora da Loja
    Solfácil.
form:
  payment_model:
    invoice_approved: Nota fiscal aprovada
    correction_letter_approved: Carta de correção aprovada
  alert_required_fields: Por favor, preencha todos os campos obrigatórios.
  required: Campo obrigatório
  file_required: É necessário anexar um arquivo.
  invalid_file_type: |
    Tipo de arquivo inválido. Tipos de arquivo aceitos: {types}
  invalid_document: Documento deve ser válido
  past_date_required: Idade inferior ao mínimo permitido.
  invalid_phone: Número deve ser válido
  invalid_cnpj: Digite um CNPJ válido
  invalid_cpf: Digite um CPF válido
  invalid_email: E-mail deve ser válido
  invalid_emails: Insira um email válido. Se houver mais de um, separe-os com vírgulas.
  repeated_document: O CPF não pode ser igual ao do cliente.
  name: Nome Completo
  cpf: CPF
  cpf_duplicate: O CPF informado já está sendo utilizado por outro cadastro.
  cnpj: CNPJ
  cepNotFound: CEP não encontrado
  cepInfo: >-
    O CEP precisa ser o mesmo utilizado para entregas dos Correios, mesmo que
    conste outro na conta de luz. Caso a dúvida persiste, clique no botão abaixo
    "Problemas com o CEP?".
  informativeCepText: Problemas com o CEP?
  validatedCep: CEP validado com sucesso.
  phone: Celular
  email: E-mail
  validatedEmail: E-mail validado com sucesso.
  nationality: Nacionalidade
  birthdate: Data de Nascimento
  occupation: Profissão
  gender: Gênero
  mother_name: Nome da mãe
  energy_concessionaire: Concessionária
  installation_phase: Fase do local da instalação
  inverter: Marca e modelo do inversor
  battery: Marca e modelo bateria
  quantity: Quantidade
  battery_quantity: Quantidade de baterias
  module_quantity: Quantidade de módulos
  inverter_quantity: Quantidade de inversores
  modules: Marca e modelo dos módulos
  microinversor_quantity: Quantidade de microinversores
  microinversors: Marca e modelo dos microinversores
  button:
    add_inverter: Adicionar inversor
    add_battery: Adicionar bateria
  installments: Parcelado
  service_invoice: Nota fiscal cheia do projeto emitida pela sua empresa*
  project_invoice: Nota fiscal do projeto*
  equipment_invoice: Nota fiscal dos equipamentos*
  error: Cadastro não realizado, tente novamente em instantes.
  cepModal:
    title: Problemas com o CEP?
    titleButton: Fechar
    informative:
      title: >-
        Caso tenha problemas com o CEP, assista ao vídeo ou siga os passos
        abaixo:
      item1: '1º Acesse ao site Buscar CEP dos correios:'
      item2: >-
        2º No primeiro campo, escreva o nome da rua, cidade e Unidade Federal
        (abreviado). No segundo campo não é necessário fazer alterações.
      item3: 3º Preencha o código exibido na imagem, e clique no botão "Buscar".
      item4: >-
        4º Na tela seguinte vai aparecer o CEP que precisa ser informado na
        plataforma.
      item5: >-
        5º Se as dúvidas persistirem, assista o vídeo acima para mais
        informações
  cancelAnalysis:
    confirm: Confirmar cancelamento
    back: Voltar
    title: Cancelar a análise?
    message: >-
      Ao cancelar, você poderá editar os dados desta etapa. Mas, ao reenviar,
      sua análise voltará para o fim da fila e poderá demorar mais.
    successToast: Análise cancelada com sucesso.
    errorToastDescription: Não foi possível cancelar a análise.
  toast:
    success: Cadastro realizado com sucesso!
  optional_placeholder: Opcional
  invalidCep: CEP Inválido
  correction_letter: Carta de correção
  email-invalid: E-mail inválido
  email-required: E-mail é obrigatório
  guarantor:
    button: Analisar crédito
    placeholder: CPF avalista
    valid_cpf: Digite um CPF válido
    error_toast_default: Erro ao incluir avalista. Tente novamente.
    error_toast_guarantor_same_document: CPF do avalista não pode ser o mesmo do cliente
  cpf_required: CPF é obrigatório
  correnction_letter:
    helper_text: Adicione a carta de correção para para ajustar seu projeto
  max: Máximo de {max} caracteres
  invalid_cep: CEP inválido
company:
  information: Dados da empresa
  name: Razão social
  name_placeholder: Insira a razão social
  phone: Telefone da empresa
  phone_placeholder: (00) 0 0000-0000
  email: E-mail da empresa
  email_placeholder: Insira o e-mail empresarial
  official_document: Documento de oficialização da empresa
  document: CNPJ
  document_placeholder: 00.000.000/0000-00
  energy_bill: Conta de luz
  energy_bill_subtitle: >-
    Iremos solicitar o envio da conta de luz na etapa de documentação. Se não
    estiver no nome do cliente, basta indicar o CPF do titular.
  energy_bill_is_the_same_of_client: A conta de luz está no nome do seu cliente?
  majority_section: Documentação do sócio majoritário
  majority_subtitles: >-
    Sócio majoritário é aquele que possui a maior participação dentro do quadro
    societário da empresa. Essa pessoa se enquadra como devedor solidário.
  majority_is_the_same_of_the_legal: Sócio majoritário, também é o representante legal?
  has_more_than_one_legal_representative: Na empresa, existe apenas um representante legal?
  legal_representant_section: Dados do representante legal
  legal_representant_subtitle: >-
    Responsável por desempenhar todas as funções administrativas da empresa
    respondendo legalmente pelo CNPJ e outras ações gerenciais devidamente
    indicadas no contrato social.
  second_legal_representant_section: Dados do segundo representante legal
  alertDocumentTitle: >-
    Notamos que o endereço na conta de luz, está diferente do endereço de
    instalação
  alertDocumentMessage: >-
    Revise os campos abaixo com o local de instalação para confirmar, ou anexe
    uma nova conta de luz do local da instalação.
  alertRepresentantLegalMissingTitle: >-
    Notamos que o cliente PJ precisa preencher informações sobre representante
    legal
  alertRepresentantLegalMissingMessage: Confira e confirme abaixo os dados do representante legal
  biometry:
    modal_sending:
      majority_info:
        title: Dados de contato do sócio majoritário
        description: O pedido de coleta da biometria será enviado ao sócio majoritário usando estas informações.
      first_legal_info:
        title: Dados de contato do 1º representante legal
        description: O pedido de coleta da biometria será enviado ao representante legal usando estas informações.
      second_legal_info:
        title: Dados de contato do 2º representante legal
        description: O pedido de coleta da biometria será enviado ao 2º representante legal usando estas informações.
      guarantor_info:
        title: Dados de contato do avalista
        description: O pedido de coleta da biometria será enviado ao avalista usando estas informações.
      title: Por favor, confirme os seguintes dados
      helper_text:
        edit_suggestion:
          first_line: 'Lembre-se: você possui'
          second_line: '{count} tentativas'
          last_line: para alterar os endereços de envio da biometria
        no_changes:
          first_line: 'Lembre-se: você'
          second_line: não possui mais tentativas
          last_line: para alterar os endereços de envio da biometria
      send: Confirmar e avançar
      confirm_edit: Confirmar alteração
      edit: Editar dados
      cancel: Cancelar
      back: Voltar
      form:
        email: E-mail
        phone: Celular
        required: Campo obrigatório
        email_error: Informe um e-mail válido
        phone_error: Informe um telefone celular válido
        submit: Confirmar edição
        majority:
          email: E-mail do sócio majoritário
          phone: Celular do sócio majoritário
        legal:
          email: E-mail do representante legal
          phone: Celular do representante legal
        legal_1:
          email: E-mail do 1º representante legal
          phone: Celular do 1º representante legal
        legal_2:
          email: E-mail do 2º representante legal
          phone: Celular do 2º representante legal
customer:
  new: Proposta
  confirm: Confirmar dados
  client_data: Dados do cliente
  equipment_edit_modal:
    title: Descartar alteração?
    description: Ao sair da edição de equipamentos, as alterações feitas serão descartadas.
    confirm: Descartar
    cancel: Voltar à edição
  equipment_success_update: Equipamentos atualizados com sucesso
  equipment_success_save: Equipamentos salvos com sucesso
  equipment_error_save: Erro ao salvar os equipamentos. Tente novamente mais tarde.
  distributor_installation_guard:
    mismatch:
      title: Divergência entre concessionária e endereço
      description: O estado da concessionária selecionada não corresponde ao estado do endereço de instalação.
  equipment_step:
    subtitle: Informe os equipamentos que serão comprados e financiados neste projeto.
    section_title: Kit que será financiado
    loading: Carregando informações dos equipamentos
    deadline_alert:
      title: Fique atento aos prazos e evite bloqueios
      description: 'Você tem até {date} para concluir os passos Equipamentos e Recebimento.'
    origin:
      label: Onde os equipamentos serão comprados?
      solfacil: Solfácil
      other: Outra distribuidora
      combo_info: Para projetos com Combo, os equipamentos devem ser comprados na Solfácil.
    acquisition:
      label: Forma de aquisição do kit
      store: Pedido na loja
      container: Saldo container
      container_info: Selecione Saldo container caso queira utilizar equipamentos que estão em seu estoque na Solfácil.
      options:
        mirror: Pedido na loja
        selected: Outra distribuidora
        container: Saldo container
        own_equipment: Estoque próprio
    store_order_reason_alert:
      title: Pendência!
      expired_description: seu pedido está cancelado ou expirado. Ele deve estar no status de aguardando pagamento.
      not_payment_description: Seu pedido não está em um status esperado para essa etapa. Ele deve estar no status de aguardando pagamento.
    store_order:
      label: Pedido na loja
      placeholder: Selecione o pedido realizado na loja Solfácil...
      no_order: Ainda não fiz o pedido
      view_order: Ver meu pedido
      expires_at: Este pedido expira em {date}.
      expired_at: Este pedido expirou em {date}. Escolha outro pedido.
      option: 'Pedido #{id} - R$ {value}'
      errors:
        invalid_for_combo_conecte: Pedido não compatível com Combo Conecte
        size_incompatible: O pedido selecionado incompatível com o tamanho do projeto.
        invalid_for_project_title: O pedido selecionado não é válido para o projeto.
        used_another: Este pedido já está vinculado a outro projeto.
        invalid_power: Informação de potência inválida para o equipamento.
        invalid_battery: Informação de bateria inválida para o equipamento.
        order_expired: O pedido selecionado está cancelado ou expirado. Escolha outro pedido no status de aguardando pagamento.
        order_not_payment: Seu pedido não está em um status esperado para essa etapa. Escolha outro pedido no status de aguardando pagamento.
    project_details:
      phase: Fase do local da instalação
      structure: Estrutura
      structure_placeholder: Selecione...
      system_power: Potência do sistema
      battery_capacity: Capacidade da bateria
      system_type: Tipo de sistema
      system_type_without_battery: Sem bateria
      system_type_with_battery: Com bateria
      system_type_only_battery: Somente bateria
    actions:
      save_continue: Salvar e continuar
      verify: Verificar informações
      verified: Equipamentos verificados
    unit_kwp: '{value} kWp'
  client_data_subtitle: Responda os campos abaixo com os dados do seu cliente
  use_terms: >-
    Eu e o cliente concordamos com os Termos de Uso, com o Termo de Autorização
    de Consulta ao SCR e com a Política de Privacidade da Solfácil. O Cliente
    autoriza a consulta de seus dados pessoais junto aos Órgãos de Proteção ao
    Crédito.
  confirm_modal: >-
    Não é possível fazer alterações nos dados do cliente futuramente. Uma vez
    confirmado, caso seja necessário fazer alterações um novo projeto deverá ser
    criado.
  attention: Atenção
  document_data_title: Documentação
  document_data_subtitle: >-
    Anexe abaixo os seguintes documentos do seu cliente. De preferência para
    arquivos em .pdf.
  address_data_title: Endereço residencial
  address_data_subtitle: Preencha igual está na conta de luz
  project_data_title: Equipamentos
  project_data_subtitle: Adicione as informações técnicas e o equipamento.
  receipt_model_title: Recebimento
  receipt_model_subtitle_combo: >-
    Confirme o seu modelo de recebimento para que possamos realizar as
    transferências para a sua conta.
  receipt_model_subtitle_default: >-
    Confirme os detalhes do seu modelo de recebimento e envie as notas fiscais.
  receipt_model_subtitle_default_complement: >-
    Após a análise, acompanhe os valores a serem recebidos e os comprovantes das
    transferências.
  invoice_deadline_alert:
    title: >-
      Você tem até {date} para submeter as notas fiscais e confirmar suas
      informações de recebimento.
    title_no_date: >-
      Não deixe de submeter as notas fiscais e confirmar suas informações de
      recebimento dentro do prazo.
    text: >-
      Fique atento ao prazo. Em caso de não cumprimento, sua empresa poderá ser
      bloqueada para novos projetos.
  in_cash_subtitle_with_combo: >-
    Todo valor, descontado o kit, à vista para você após a aprovação do(s)
    pedido(s) vinculado(s) ao projeto.
  in_cash_subtitle_without_combo: >-
    Todo valor à vista para você após aprovação do contrato e nota(s)
    fiscal(is).
  in_installment_subtitle: >-
    Primeiro pagamento após aprovação do contrato e nota(s) fiscal(is), segundo
    pagamento após validação da instalação. | O valor dos equipamentos será pago
    à vista para o fornecedor. Metade do valor restante financiado será pago
    após aprovação do contrato e nota(s) fiscal(is), a outra metade após
    validação da instalação.
  in_installment_without_service_invoice_subtitle: >-
    Primeiro pagamento após aprovação do contrato, segundo pagamento após a
    validação da instalação.
  invoice_subtitle: >-
    O envio das notas pode ser feito após a assinatura do contrato. Depois de
    assinado você vai ter 10 dias para submeter as notas, caso contrário sua
    empresa ficará bloqueada para novos projetos. Dê preferência para arquivos
    no formato .pdf. | O envio da nota pode ser feito após a assinatura do
    contrato. Depois de assinado você vai ter 10 dias para submeter as notas,
    caso contrário sua empresa ficará bloqueada para novos projetos. Dê
    preferência para arquivos no formato .pdf.
  transfer_after_project_approval: Transferência após aprovação do projeto
  transfers_after_project_formalization_supplier: >-
    Transferência de {percent}% referente ao valor do kit após formalização do
    projeto
  transfer_after_project_formalization_commission_insurance: Transferência de comissão de seguro após a aprovação do contrato
  transfer_after_project_formalization_commission_financing: Transferência de comissão de financiamento após a aprovação do contrato
  after_contract_approval_value_will_be_transferred: Após a aprovação do contrato o valor será transferido para sua conta.
  after_installation_value_transfer: >-
    Após a aprovação da instalação o valor bloqueado será transferido para sua
    conta.
  commission_transfer_after_nf_approval: >-
    O valor da comissão será transferido após a aprovação da NF de comissão. O
    valor bloqueado será transferido após a validação da instalação.
  value_transfer_after_validation_installation: O valor bloqueado será transferido após a validação da instalação.
  alertDocumentTitle: >-
    Notamos que o endereço na conta de luz, está diferente do endereço de
    instalação
  alertDocumentMessage: >-
    Revise os campos abaixo com o local de instalação para confirmar, ou anexe
    uma nova conta de luz do local da instalação.
  alertInstallment: >-
    Você receberá o pagamento em duas parcelas: após aprovação do contrato e
    após aprovação da instalação. Ainda somos responsáveis pelo pagamento do kit
    do seu projeto, por isso pedimos dados do fornecedor.
  method_receipt_seleted_in_cash: >-
    Neste cenário a Solfácil paga à vista: 100% do dinheiro para você e você
    paga o fornecedor.
  method_receipt_seleted_installment: >-
    Neste cenário a Solfácil paga 60% do valor do projeto na formalização. Os
    40% restantes serão pagos na conclsão da instalação.
  invoice_value: Valor da nota fiscal do kit
  invoice_value_placeholder: Digite o valor da nosta fiscal do kit
  titleUnableContinuefinancing: Não conseguimos seguir com esse financiamento
  descriptionUnableContinuefinancing: >-
    Alguns dados do cliente podem precisar de ajustes. Por favor, verifique se o
    contato e o endereço pertencem ao cliente, e não ao vendedor ou a um
    parente. Após essa confirmação, crie um novo projeto e envie para análise.
    Lembramos que, ainda assim, o sistema pode reprovar automaticamente a
    proposta em alguns casos conforme nossa política interna.
  endButtons:
    backSimulation: Voltar para simulação
    nextInstallation: Ir para instalação
  header:
    title: Projeto
    steps:
      simulation: Simulação
      formalization: Proposta
      installation: Instalação
    tags:
      pending: Em andamento
      pendency: Pendenciado
      kit_pending: Kit pendente
      under_analysis: Em análise
      submitted: Enviado
      send_contract: Enviar contrato
      sent: Pendente cliente
      reproved: Reprovado
      canceled: Cancelado
      approved: Aprovado
      expired: Expirado
    message:
      error: Ocorreu um erro ao obter os status da proposta.
  biometry:
    formalization_started: Formalização iniciada com sucesso
    cancel_success: O envio da biometria foi cancelado
    step_subtitle: Confirme os dados abaixo e, em seguida, peça ao seu cliente que faça a biometria e assine o contrato.
    confirm_and_advance: Confirmar e avançar
    confirmation:
      title: Verificação de informações do projeto
      description: Confirme os dados abaixo antes de enviar os documentos para assinatura do cliente.
      status_in_progress: Em andamento
      status_approved: Aprovado
    steps_box:
      title: Passos a serem realizados pelo seu cliente
      description: Após a confirmação acima, acompanhe seu cliente nos passos a seguir.
    compatibility:
      title: Compatibilidade dos inversores
      consult_before: Consulte a lista de
      consult_link: inversores compatíveis com o Combo Conecte
      consult_after: Em seguida, faça um pedido na loja para validar a sua escolha.
      order_label: Pedido na loja
      order_placeholder: Selecione o pedido
      order_option: 'Pedido #{id} - R$ {value}'
      go_to_store: Ir para a loja
      see_inverters: Ver inversores compatíveis
      change_later: Você poderá trocar de pedido depois, se precisar.
      errors:
        incompatible: Este pedido não é compatível com o Combo Conecte. Selecione outro pedido.
        expired: Este pedido está expirado. Selecione um novo pedido.
        generic: Não foi possível validar o pedido. Selecione outro pedido.
    edit_modal:
      title: Alteração de dados do cliente
      warning_before: Esta alteração pode ser feita
      warning_times: '{count} vezes'
      warning_after: Ao salvar, o projeto passará por uma nova análise.
      email_label: E-mail do cliente
      phone_label: Celular do cliente
      cancel: Cancelar
      save: Salvar alteração
    title: Biometria e contrato
    subtitle: >-
      Informe seu cliente como é o processo da realização da biometria e
      assinatura do contrato do financiamento.
    steps:
      send_contract: Envio da biometria e do contrato
      biometry: Biometria
      contract: Contrato
      approval: Aprovação do contrato
      toast:
        informative:
          not_found:
            title: Biometria não realizada
            description: >-
              Não foi identificado o envio da biometria. Por favor, conclua
              biometria para avançar de etapa.
    description:
      send_biometry_contract:
        days: >-
          Após você clicar em "Enviar", o seu cliente vai receber um e-mail com
          o link para realizar a biometria facial e depois outro para assinar o
          contrato eletronicamente. O cliente terá {days} dias para completar
          cada uma das duas etapas. Se não, o link vai expirar e um novo e-mail
          será enviado automaticamente;
        minutes: >-
          Caso o seu cliente não tenha recebido o e-mail da biometria ou do
          contrato, é possível reenviar {minutes} minutos após o primeiro envio;
        sign: >-
          Para assinar o contrato é necessário informar um Token (código de
          confirmação) recebido pelo celular. Selecione abaixo a melhor forma
          para o seu cliente receber o Token.
        radio:
          label: Forma de recebimento do Token
          sms: SMS
          whatsapp: WhatsApp
      biometry: >-
        O seu cliente receberá um WhatsApp com as instruções para realizar a
        biometria facial. Se houver avalista, ele (a) também precisará realizar
        esse processo.
      has_biometric: O seu cliente poderá realizar a biometria em conjunto a assinatura do contrato. Se houver avalista, ele (a) também precisará realizar esse processo.
      contract: >-
        Concluída a biometria, seu cliente receberá um e-mail para assinar o
        contrato eletronicamente. Uma vez assinado, ele receberá uma cópia por
        e-mail.
      approval: Etapa de confirmação e aprovação do time Solfácil
    alert:
      under_analysis:
        title: Contrato e biometria realizados pelo cliente e está em análise
        text: >-
          Nosso time está analisando a documentação e em breve traremos a
          resposta.
      pending:
        title: Problema no resultado da biometria
        text: Um novo e-mail já foi enviado ao cliente para uma nova tentativa.
      reproved_biometry:
        title: Cliente reprovado na biometria ou assinatura do contrato
        subtitle: >-
          Seu cliente foi reprovado nessa etapa devido a inconsistências e por
          isso esse projeto não pode ser formalizado. Esse tipo de reprova é
          irreversível.
      reproved:
        title: Não é possível seguir com este financiamento
        subtitle: O mesmo cliente já tem um projeto formalizado com a Solfácil.
      pendencies: >-
        Regularize sua situação conosco até {date} para seguir com a
        formalização desse projeto.
      blocklist:
        title: Blocklist
      status_reason:
        reproved:
          title: Formalização reprovada!
        cancelled:
          title: Formalização cancelada!
        blocklist_pending:
          title: Formalização pendente!
    status:
      sent_message: Enviado
      waiting_biometry: Aguardando envio
      waiting: Aguardando
      in_progress: Em andamento
      pending: Enviar contrato
      pendency: Pendenciado
      sent: Pendente cliente
      under_analysis: Em análise
      reproved: Reprovado
      approved: Aprovado
      accomplished: Realizada
      signed: Assinado
    date:
      last_submitted_at: 'Último envio:'
      completed_at: 'Concluído em:'
      not_started: (não iniciado)
      in_progress: (em andamento)
    footer:
      policy: Acessar política de cancelamento
      resend: Reenviar
      cancel: Editar dados do projeto
      contract: Visualizar documentos
      terms: Visualizar termos
      insurance: Baixar apólice
      view: Visualizar
    buttons:
      resend_biometry: Reenviar biometria
      resend_contract: Reenviar contrato
    resend:
      success:
        title: Reenvio realizado
        biometry_description: Biometria reenviada com sucesso
        contract_description: Contrato reenviado com sucesso
      error:
        title: Erro no reenvio
        biometry_description: Erro ao reenviar biometria. Tente novamente.
        contract_description: Erro ao reenviar contrato. Tente novamente.
      wait: Aguarde... {seconds}s
    modal_cancel:
      title: Deseja seguir com a alteração?
      description: >-
        Ao seguir com essa alteração dos dados do cliente as etapas de biometria
        e contrato serão cancelados e após a alteração nos dados será necessário
        realizar as etapas citadas novamente.
      confirm: CONFIRMAR
      cancel: CANCELAR
    catch:
      data_error_title: Biometria indisponível no momento
      data_error: Atenção! Ocorreu um erro ao obter os dados da biometria.
      send_error: >-
        Atenção!Ocorreu um erro ao enviar o contrato e a biometria. Tente
        novamente.
      resend_error: >-
        Atenção!Ocorreu um erro ao reenviar o contrato e a biometria. Tente
        novamente.
      cancel_error: >-
        Atenção!Ocorreu um erro ao cancelar o contrato e a biometria. Tente
        novamente.
      update_error: >-
        Devido a nossas políticas internas, não é possível seguir com a
        alteração.
      know_errors:
        BIOMETRY_ALREADY_DONE: Não foi possível atualizar pois a biometria já foi realizada
        FORMALIZATION_COMPLETED: Não foi possível atualizar pois a formalização já foi finalizada
        INVALID_STATUS: Não foi possível atualizar pois o status é inválido
        MAX_TRIES: Não foi possível atualizar pois o limite de tentativas foi atingido
        MATRIX_RESTRICTIONS: >-
          Devido a nossas políticas internas, não é possível seguir com a
          alteração
        SAME_EMAIL_PHONE: Não foi possível atualizar pois o e-mail e o telefone são os mesmos
        LIMIT_CHANGES_EXCEEDED: Quantidade de tentativas excedida
      has_been_cancelled: >-
        O contrato foi cancelado, aguarde {minutes} minuto(s) para cancelar
        novamente
    update_success: Os dados para contato foram alterados com sucesso
    modal_sending:
      due_date:
        title: Vencimento das parcelas
        description: Lembre seu cliente destas datas e altere, se necessário.
        first_due_date: Vencimento da primeira parcela
      due_day: Dia do vencimento
      contact_info:
        title: Dados de contato do cliente
        description: Onde seu cliente receberá as instruções e o contrato.
      guarantor_info:
        title: Dados de contato do avalista
        description: O pedido de coleta da biometria será enviado ao avalista usando estas informações.
      title: Por favor, confirme os seguintes dados
      helper_text:
        edit_suggestion:
          first_line: Esta alteração pode ser feita
          second_line: '{count} vezes.'
          last_line: Ao salvar, o projeto passará por uma nova análise.
        no_changes:
          first_line: 'Lembre-se: você'
          second_line: não possui mais tentativas
          last_line: para alterar os endereços de envio da biometria
      send: Confirmar e avançar
      back: Voltar
      confirm_edit: Confirmar alteração
      edit: Alterar
      cancel: Cancelar
      form:
        required: Campo obrigatório
        email: E-mail
        email_error: Informe um e-mail válido
        phone: Celular
        phone_error: Informe um telefone celular válido
        submit: Confirmar edição
        email_guarantor: E-mail do avalista
        phone_guarantor: Celular do avalista
    button:
      check-complete-biometry: Confirmar biometria
  terms_acceptance:
    title: Termos de aceite do Combo Conecte
    subtitle: >-
      O seu cliente receberá um whatsapp e e-mail com instruções para realizar a assinatura dos termos de aceite em que confirma estar ciente da necessidade do acesso a internet via rede wifi para o inversor se manter conectado e assim validando a adesão do Combo Conecte.
    button:
      send_terms: Enviar o termo para assinatura
      resend_terms: Reenviar o termo para assinatura
    resend:
      success:
        title: Reenvio realizado
        description: Termo reenviado com sucesso
      error:
        title: Erro no reenvio
        description: Erro ao reenviar termo. Tente novamente.
      wait: Aguarde... {seconds}s
    catch:
      send_error: >-
        Atenção! Ocorreu um erro ao enviar o termo. Tente novamente.
      resend_error: >-
        Atenção! Ocorreu um erro ao reenviar o termo. Tente novamente.
  bannerSolfacilPlus:
    titlePrimary: Parabéns pela formalização! Você ganhou
    titleSecondary: pontos no Solfácil Mais
  canceled:
    title: Projeto cancelado
    description: >-
      O cliente solicitou o cancelamento deste projeto e a transferência de
      valores não será realizada. Se já foi feita, ela será estornada. Em caso
      de Combo Fácil, o pedido do kit também será cancelado.
    risk_title: Não conseguimos seguir com esse financiamento
    risk_description: >-
      A proposta foi reprovada na etapa de validação de dados devido a
      inconsistências nas informações apresentadas, conforme previsto em nossa
      política interna.
    internal_policy_title: Reprova definitiva
    internal_policy_description: Cliente em desacordo com a política interna.
    requested_by_customer_title: Projeto Cancelado
    requested_by_customer_description: >-
      O cliente solicitou o cancelamento deste projeto e a transferência de valores não será realizada. Se já foi feita, ela será estornada. Em caso de Combo Fácil, o pedido do kit também será cancelado.
  guarantor_section_title: Insira os dados pessoais do(a) avalista
  customer_section_title: Insira os dados pessoais do(a) cliente
  equipment_update:
    alert:
      contract_generated_title: A alteração de equipamentos gerará um aditivo contratual que deverá ser assinado pelo seu cliente.
      contract_generated_description: Ao confirmar a alteração, seu cliente receberá o termo para assinatura. Após assinado, a alteração será efetivada.
      pending_title: Há um pedido de alteração pendente.
      pending_description: A alteração de equipamentos solicitada será efetivada assim que o seu cliente assinar o Termo de Aditamento do Financiamento (TAF).
      pending_edit_title: Alteração de equipamentos em aberto
      pending_edit_description: Você iniciou a edição dos equipamentos, mas ainda não salvou. Antes de continuar, verifique as informações e salve ou cancele a edição.
      pending_biometry_timeline_title: Aditivo contratual pendente de assinatura do cliente
      pending_biometry_timeline_description: Seu cliente precisa assinar o Termo de Aditamento do Financiamento (TAF) para confirmar as alterações solicitadas na proposta.
    modal:
      details_title: Detalhes da alteração de equipamentos
      details_description: Para que a alteração seja efetivada, é necessário que seu cliente assine o Termo de Aditamento de Financiamento (TAF) enviado.
      details_subtitle: Estes foram os equipamentos informados nesta alteração
      details_primary: Reenviar termo ao cliente
      details_secondary: Cancelar alteração
    button:
      view_details: Ver detalhes
      resend_term: Reenviar termo
      cancel: Cancelar alteração
    toast:
      resend_success_title: O termo foi reenviado ao cliente
      resend_success_description: O Termo de Aditamento do Financiamento foi reenviado ao seu cliente para assinatura.
      cancel_success_title: O pedido de alteração foi cancelado
      cancel_success_description: A alteração de equipamentos que você solicitou foi cancelada.
      cancel_error_title: Erro ao cancelar pedido de alteração
      cancel_error_description: Ocorreu um erro ao cancelar o pedido de alteração. Tente novamente.
      update_success_title: Alteração solicitada com sucesso
      update_success_without_taf_description: O seu equipamento foi alterado com sucesso.
    tag:
      pending: Solicitação de alteração pendente
      mr_pending: Requer conclusão do passo 3
solfacilPoints:
  label: Pontos Solfácil+
  phrases:
    one: 'Que tal adicionar em seu financiamento:'
    two: Vamos melhorar o projeto? Que tal adicionar
    three: Bom projeto! Que tal adicionar {string}?
    four: Formalizar esse projeto vai te trazer muitos benefícios! Muito bem!
toastKitSelected:
  title: Kit selecionado
  description: >-
    Caso disponível no momento da formalização, o kit será faturado
    automaticamente para sua comodidade.
company_form_document:
  label_document_majority_and_legal_representants: >-
    RG ou CNH do sócio majoritário e representante(s) legal(is) (caso
    aplicável)*
  label_energy_bill: Conta de luz do local da instalação*
  label_document_company: Documentos de oficialização da empresa*
  label_additional_document: Documentos adicionais
  label_subtitle_document_majority_and_legal_representants: >-
    Aceitamos: RG ou CNH ou CNH Digital + QR Code ou CTPS física ou carteira de
    classe ativa com foto. Documentos devem conter o número do CPF.
  label_subtitle_energy_bill: >-
    Agilize sua análise! Dê preferência para arquivos em .pdf do site da
    concessionária. Envie a conta completa, em nome da pessoa física ou jurídica
    com até 90 dias de emissão.
  label_subtitle_document_company: >-
    Aceitamos um desses documentos: declaração de microempreendedor individual
    (MEI), contrato social, requerimento de empresário ou, na ausência destes,
    certidão emitida pela Junta Comercial.
  label_subtitle_additional_document: >-
    Se o local de instalação não for o endereço do CNPJ ou da residência do
    representante legal ou coobrigado, será necessário enviar um comprovante de
    residência no nome de uma dessas três entidades do local de instalação.
  additional_comments: Comentários adicionais
  placeholder: Arraste o arquivo aqui ou clique para upload
  placeholder_additional_comments: Opcional
formDocument:
  labelDocument: RG ou CNH*
  labelDocumentSol: RG ou CNH do cliente*
  labelElectricityBill: Conta de luz do local da instalação*
  labelAdditionalDocument: Documentos adicionais
  labelSubtitleDocument: >-
    Aceitamos: RG ou CNH ou CNH Digital + QR Code ou CTPS física ou carteira de
    classe ativa com foto. Documentos devem conter o número do CPF.
  labelSubtitleElectricityBill: >-
    Agilize sua análise! De preferência para arquivos em .pdf do site da
    concessionária. Envie a conta completa, em nome da pessoa física ou jurídica
    de até 90 dias de emissão.
  labelSubtitleAdditionalDocument: >-
    Não obrigatório. Exemplo: comprovante de vínculo entre o cliente financiador
    e o titular da conta de luz.
  additionalComments: Comentários adicionais
  placeholder: Arraste o arquivo aqui ou clique para upload
  placeholderAdditionalComments: Opcional
  helperText: Somente arquivos .jpg com tamanho máximo de arquivo de 500kb
  errorMessage: Inisira um novo documento
  errorMessageInstallationAddressMatchesBill: >-
    Conta de luz não bate com local de instalação. Envie novamente o documento
    de conta de luz e caso necessário atualize o endereço de instalação em
    'Dados do cliente'.
  errorMessageInstallationDocumentMatchesBill: Documento não bate com CPF registrado.
  errorMessageInstallationDocumentMatches: CPF não bate com documento registrado
  errorMessageInstallationAddressAndDocumentMatchesBill: >-
    Conta de luz não bate com local de instalação e com o documento informado.
    Envie novamente o documento de conta de luz, caso necessário atualize o
    endereço de instalação e o documento em 'Dados do cliente'.
  errorMessageIdentityMatchesDocument: Documento não bate com CPF registrado, faça o upload do arquivo novamente.
  messageTitleAwaitingCustomerData: Aguardando Dados do cliente
  messageTextAwaitingCustomerData: >-
    Para finalizar a análise dos documentos abaixo, por favor faça o
    preenchimento da etapa de "Dados do cliente".
  alertError: Inconsistência na análise da documentação
  responseError: >-
    Erro ao enviar o arquivo, verifique o tipo do arquivo ou o tamanho e tente
    novamente.
  responseErrorDelete: Erro ao deletar o arquivo, por favor tente novamente.
  responseSuccessDelete: Arquivo deletado com sucesso.
formAddress:
  countryside: Endereço está em Zona Rural?
  yesCountryside: Sim
  noCountryside: Não
  cep: CEP*
  installationStreet: Rua da instalação*
  street: Rua*
  street_placeholder: Rua, alameda, avenida...
  number: Número*
  complement: Complemento
  complementPlaceholder: Apt, bloco...
  neighborhood: Bairro*
  neighborhood_placeholder: Nome do bairro
  state: Estado*
  city: Cidade*
  city_placeholder: Nome do município
  local: Local de residência do cliente, é o mesmo local da instalação?
  yesLocal: Local de residência, é o mesmo do local da instalação
  noLocal: Local de residência e instalação não são os mesmo
  titleInstallationLocation: Complete as informações do local de instalação
  addressInstallation: Endereço do local de instalação
subscriptionEnergy:
  title: Seu cliente ainda pode ter energia solar!
  subtitle: >-
    Indique seu cliente para ter energia solar por assinatura com até 20% de
    desconto na conta de luz! E ganhe uma comissão caso ele aceite!
  recommend_customer: Indicar cliente
  alt_img: Imagem Energia Solar por Assinatura
  title_img: Energia Solar por Assinatura
electricityBill:
  yesMessage: Sim
  noMessage: Não
  title: Conta de luz
  description: >-
    Iremos solicitar o envio da conta de luz na etapa de documentação. Se não
    estiver no nome do cliente, basta indicar o CPF do titular.
  question: A conta de luz está no nome do seu cliente?
  placeholder: Informe o CPF que consta na conta
  errorMessageInstallationDocumentMatchesBill: CPF não bate com documento registrado
  errorMessageInstallationDocumentMatchesBillCompany: CNPJ não bate com documento registrado
  errorMessageCompany: Documentos da empresa não batem com o registrado
emptyStateCustomer:
  title: Sem informações disponíveis
  subtitle: Não há informações sobre os dados do cliente.
installationPage:
  messageNewInstallation: Instalação
  barInstallation:
    waiting:
      type: informative
      text: Em andamento
    processing:
      type: warning
      text: Em análise
    error:
      type: negative
      text: Pendenciado
    success:
      type: positive
      text: Instalado
  helpButton: Dúvida na ativação do Ampera
  manualButton: Seguir manualmente
  amperaExperienceButton: Experiência Ampera
  waiting:
    img:
      name: ampera.svg
      alt: Imagem do equipamento ampera
      title: Ampera
    pageTitle: Validar instalação com Ampera
    title: Aguardando ativação do Ampera
    subtitle: >-
      [strong]Caso façam mais de 15 minutos que você instalou o Ampera e ele não
      foi ativado,[/strong] siga para a validação manual.
  waitingMultiples:
    img:
      name: ampera.svg
      alt: Imagem do equipamento ampera
      title: Ampera
    title: >-
      Ao concluir a instalação, adicione fotos ou vídeos do seu projeto nos
      campos abaixo
    subtitle: >-
      Com o Ampera ativado após a instalação você não precisa passar por essa
      etapa. Porém como você ainda não tem 3 projetos instalados na Solfácil,
      precisamos que você anexe alguns arquivos para que possamos validar a
      instalação do seu projeto.
  waitingAmperaActivated:
    img:
      name: ampera.svg
      alt: Imagem do equipamento ampera
      title: Ampera
    title: Seu Ampera já foi ativado, você já quase concluiu seu projeto
    subtitle: >-
      Precisamos de fotos ou vídeos para validar esta instalação, mas após a
      terceira instalação, os projetos seguintes com Ampera, você pula essa
      etapa. O Ampera valida a instalação para você!
  waitingWihtoutAmpera:
    img:
      name: installation.svg
      alt: Imagem representando instalção
      title: Instalação
    title: >-
      Ao concluir a instalação, adicione fotos ou vídeos do seu projeto nos
      campos abaixo
    subtitle: >-
      Cansado de subir fotos pra comprovar instalação? Com Ampera em seus
      projetos, além de contar com monitoramento inteligente das suas usinas,
      com a ativação do Ampera, você não precisar subir mais nada para comprovar
      sua instalação!
  waitingWihtoutAmperaMultiples:
    img:
      name: installation.svg
      alt: Imagem representando instalção
      title: Instalação
    title: >-
      Ao concluir a instalação, adicione fotos ou vídeos do seu projeto nos
      campos abaixo
    subtitle: >-
      Com o Ampera ativado após a instalação, você pula essa etapa! Porém, como
      você ainda não tem 3 projetos na Solfácil, envie alguns arquivos para
      validar sua instalação e desbloquear todo o potencial do Ampera!
  processing:
    img:
      name: processing.svg
      alt: Imagem representando algo em processamento
      title: >-
        Estamos analisando se está tudo certo com o Ampera, em até 24h úteis
        confirmaremos ou não a instalação.
    title: Obrigado por informar a conclusão da instalação!
    subtitle: >-
      Estamos analisando se está tudo certo com o Ampera, em até 24h úteis
      confirmaremos ou não a instalação.
  error:
    img:
      name: error.svg
      alt: Imagem representando que ocorreu um erro
      title: Por favor revise as informações abaixo.
    title: Encontramos um problema para seguir com a conclusão da instalação
    subtitle: Por favor revise as informações abaixo.
  success:
    img:
      name: success.svg
      alt: Imagem representando que houve sucesso
      title: Concluído
    title: Instalação validada com sucesso!
    subtitle: Concluído em {date} às {hour}
  titleAddFiles: Valide sua instalação por foto
  descriptionAddFiles: >-
    Caso não consiga ativar o seu Ampera, faça a validação manual do projeto
    enviando a documentação solicitava abaixo.
  descriptionAvoidFailures:
    part1: Evite reprovas!
    part2: >-
      Caso a marca do inversor tenha sido alterada, indique o modelo/potência
      nos comentários adicionais. Tamanho máximo de
    part3: 2MB por arquivo (JPEG, JPG, PNG e PDF).
  form:
    placeholderUpload: Arraste o arquivo aqui ou clique para upload
    installationField:
      label: Foto do telhado ou local da instalação
    invertersField:
      label: Foto do todos os inversores e proteções CC/CA instalados
    installedField:
      label: Foto do Ampera (com serial number visível)
    inverterLabels:
      label: Foto de todas as etiquetas de inversores (com número de série)
      helper: Certifique-se de que o Número de Série (SN) esteja legível na foto
    dataloggerField:
      label: Foto de todos os datalogger dos inversores (com número de série)
    additionalComments: Comentários adicionais
    batteryInstalled: Foto das baterias instaladas
    sendButton: Enviar para análise
    downloadFiles: Baixar arquivos
  footer:
    formalization: Ir para proposta
    ampera: Monitorar Ampera
  canceled:
    title: Projeto cancelado
    description: >-
      Este projeto foi cancelado e nenhum valor será transferido. Transferências
      já realizadas serão estornadas automaticamente.
    combo_description: O pedido do kit também foi cancelado.
  trackAmpera: Rastrear Ampera
inversorInstallation:
  form:
    title: Validar instalação com inversor
    subtitle: Selecione uma das alternativas abaixo para validar sua instalação
    inverterImageAlt: Imagem da etiqueta do inversor
    inverterDataTitle: Dados {index}˚ inversor
    inverterLabel: Foto etiqueta inversor instalado
    dataloggerLabel: Foto datalogger do inversor instalado
    placeholderUpload: Arraste ou clique para fazer upload
    removeInverter: Remover inversor
    addInverter: Adicionar inversor
    sendInfo: Enviar informações
    validateWithAmpera: Validar com Ampera
    taf_pending_tooltip: Aguarde a assinatura do Termo de Aditamento de Financiamento (TAF) para enviar as informações de instalação.
    validatePower:
      nominalPowerLabel: Potência nominal total dos inversores instalados
      defaultError: Erro ao validar a potência nominal total dos inversores instalados.
      NOT_FOUND: Não encontramos a potência nominal total dos inversores instalados.
      UNKNOWN:
        title: Erro ao validar a potência nominal total dos inversores instalados.
        description: >-
          Ocorreu um erro ao tentar validar a potência nominal total dos
          inversores instalados. Tente novamente.
      ABOVE_UPPER_LIMIT:
        title: Potência informada excede o contratado
        description: >-
          A potência inserida não condiz com a estimativa para o projeto. Revise
          esta informação.
      BELOW_LOWER_LIMIT:
        title: Potência informada é menor do que o contratado
        description: >-
          A potência inserida não condiz com a estimativa para o projeto. Revise
          esta informação.
    duplicateSerialNumber:
      title: Informações não legíveis nas imagens enviadas
      description: >-
        As informações nas imagens anexadas não estão legíveis. Verifique se
        estão com foco ou digite manualmente os dados solicitados.
    toast:
      submitInversorError: >-
        Ocorreu um erro ao tentar enviar as informações do inversor. Tente
        novamente.
  InversorInstallationConfirmation:
    title: Confirme se as informações abaixo estão corretas com o inversor instalado
    confirmButton: Confirmar dados
    reviewButton: Revisar dados
    InverterCard:
      inverter: Inversor
      brand: Marca
      potency: Potência
      serialNumber: Número de série
      datalogger: Datalogger
emptyStateInstallation:
  title: Sem informações disponíveis
  subtitle: Não há informações sobre a instalação.
bannerSolfacilPlus:
  img:
    alt: Imagem representando uma conquista.
    title: Parabéns! Você ganhou pontos extras no Solfácil Mais
  title: Parabéns! Você ganhou pontos extras no Solfácil Mais
  subtitle: Quanto mais projetos fizer com a Solfácil, maior seu nível e benefícios!
receiptModel:
  alert:
    title: >-
      Para ter acesso ao Modelo de recebimento primeiro você precisa escolher um
      kit do Combo Fácil
    text: >-
      Volte a "Dados técnicos e equipamentos" para selecionar um kit da vitrine
      ou acesse a Loja compre um kit e opte pela opção de pagamento
      "Financiamento Solfácil". Desta forma você conseguirá seguir com o Modelo
      de recebimento.
    upload_not_sent: Arquivo não enviado, tente novamente!
  alertInstallments:
    title: Modelo de recebimento em dois pagamentos ({firstValue}% e {secondValue}%)
    text: >-
      Após a aprovação do contrato, você receberá {firstValue}% do valor do
      projeto, descontados o valor do kit. Concluída a aprovação instalação os
      restantes {secondValue}%.
  error:
    title: Erro ao carregar modelo de recebimento!
    subtitle: Ocorreu um erro ao tentar carregar o modelo de recebimento.
  response:
    store_order_expired: O pedido selecionado expirou.
    error:
      title: Modelo de recebimento não enviado!
      description: Ocorreu um erro ao tentar enviar o modelo de recebimento.
    success:
      title: Modelo de recebimento enviado!
      description: O modelo de recebimento foi enviado para análise.
    error_upload:
      title: Informações incompletas
      description: >-
        Verifique se todos os campos foram preenchidos corretamente para enviar
        para análise.
    equipment_value_error: O valor do equipamento não pode ser maior que o valor do financiamento.
    email_error: >-
      Ocorreu um erro ao tentar atualizar o projeto, verifique se os e-mails
      estão corretos.
  tags:
    inAnalysis: Em análise
    approved: Aprovado
    denied: Reprovado
    inProgress: Em andamento
    pendingChange: NF Pendente
    selected: Selecionado
    transferInProgress: Transferência em andamento
project_data:
  status:
    pending: Pendenciado
    selected: Selecionado
    in_progress: Em andamento
    kit_pending: Kit pendente
    approved: Aprovado
  alerts:
    project_power: Lembre-se de que a potência do projeto, preenchida na Simulação, é de
  equipment_summary:
    title: Sobre os equipamentos
    distributor: Distribuidora
    distributor_name: Solfácil
    kit_value: Valor total do kit
    paid_directly: Valor pago diretamente à Distribuidora Solfácil.
    container_helper: Aquisição dos equipamentos via Saldo Container.
  errors:
    failed_to_load_project: Não foi possível carregar as informações do projeto. Por favor, tente novamente.
    inverter_brand_mismatch: Todos os inversores devem ser da mesma marca.
    string_overload_max: >-
      Risco de sobrecarga nos inversores. Aumente a potência dos inversores ou
      diminua a potência dos módulos.
    string_overload_min: >-
      Potência dos módulos muito baixa em relação ao inversor. Isso pode afetar
      a eficiência do sistema. Considere utilizar um inversor de menor potência
      ou adicionar mais módulos ao projeto.
    microinverter_overload_max: >-
      Potência excessiva nos microinversores selecionados. Aumente a quantidade
      ou opte por modelos de menor potência.
    microinverter_overload_min: >-
      Potência insuficiente nos microinversores selecionados. Diminua a
      quantidade de microinversores ao projeto ou escolha um modelo de potência
      superior.
    modules_price_per_watt_over: >-
      O custo por watt (R$/Wp) precisa estar dentro das políticas internas.
      Aumente a potência dos módulos para continuar
    modules_price_per_watt_under: >-
      O custo por watt (R$/Wp) precisa estar dentro das políticas internas.
      Diminua a potência dos módulos para continuar
    modules_system_power: >-
      A potência do sistema (somatório da potência dos módulos) precisa ser
      próxima daquela preenchida anteriormente na Simulação
    battery_capacity: >-
      A capacidade total das baterias precisa ser próxima daquela preenchida
      anteriormente na Simulação
    battery_capacity_over: >-
      A capacidade total das baterias está acima da capacidade simulada.
      Diminua a capacidade das baterias para continuar
    battery_capacity_under: >-
      A capacidade total das baterias está abaixo da capacidade simulada.
      Aumente a capacidade das baterias para continuar
  form:
    showcase: Via vitrine da Loja (Mais rápido)
    container: Via saldo da loja
    inverter_type: Tipo de inversor
    due_day: Dia de vencimento
    first_due_date: Data do 1º vencimento
financing:
  filters:
    title: 'Filtrar projetos por:'
    status: Status
    steps: Etapas
    combo_type:
      label: Tipo de combo
      combo: Combo Fácil
      combo_connect: Combo Conecte
    clear: Limpar filtro | Limpar filtros
  quick_filters:
    label: Filtros rápidos
    formalized_90_days: Formalizados nos últ. 90 dias
    pending_installations_90_days: Instalações pendentes há mais de 90 dias
    not_installed: Não instalados
  title: Financiamentos
  subtitle: >-
    Todos as formalizações e instalações da nova plataforma reunidas em um só
    lugar
  alert:
    title: Aqui você encontra apenas financiamentos criados na nova plataforma
    subtitle: >-
      Para acessar os financiamentos da plataforma antiga, clique no botão à
      direita.
    action: Ver lista antiga
    bill:
      title: Não conseguimos seguir com esse financiamento
      description: >-
        Infelizmente, ainda não conseguimos atender este(a) cliente. Contudo,
        uma nova tentativa poderá ser realizada daqui a 30 dias.
  banner:
    title: Parcelas mais baixas para você e seu cliente
    subtitle: Suba de nível mais rápido no Solfácil Mais e tenha sempre o melhor preço
  button:
    know_more: Saiba mais
  boxSearch:
    placeholder: Buscar por Nome, CPF/CNPJ ou ID
    button: Buscar
  emptyList:
    title: Sem projetos em andamento
    subtitle: Ops! Parece que não encontramos nada com esse filtro..
    button_list: Ver lista de simulações
  notFound:
    title: Nenhum projeto encontrado
    subtitle: >-
      Busque por outro Nome, CPF, CNPJ ou ID do projeto para encontrar o projeto
      que está buscando.
  sort_by:
    label: 'Ordenar por:'
    updated_at_desc: Últimas atualizações
    created_at_desc: Mais recentes
    created_at_asc: Mais antigos
    expires_at_asc: Expiração
  no_data: Sem dados aqui
  list:
    results_found: '{count} financiamento encontrado | {count} financiamentos encontrados'
    days_info: '- | {count} dia | {count} dias'
    expired: Expirado
    one_day_remaining: 1 dia
    days_remaining: '{days} dias'
    headers:
      id: ID
      customer_name: Nome do projeto
      financed_value: Valor financiado
      project_value: Valor do projeto
      expires_at: Expira em
      installing_time: Tempo de instalação
      installing_time_tooltip: Tempo decorrido entre a formalização do contrato e a aprovação da instalação, em dias corridos.
      step: Etapa
      deadline_for_formalization: Prazo da etapa
      validity_of_the_proposal: Validade da proposta
    status:
      pending: Em andamento
      expired: Expirado
      reproved: Reprovado
      approved: Aprovado
      under_analysis: Em análise
      pendency: Pendenciado
      send_contract: Enviar contrato
      pending_customer: Pendente cliente
      pending_receipt: NF pendente
      concluded: Concluído
      cancelled: Cancelado
      kit_pending: Kit pendente
      canceled: Cancelado
    tags:
      combo: Combo Fácil
      combo_connect: Combo Conecte
      paid_percentage: Pago {percentage}%
    step:
      simulation: Simulação
      biometry_and_contract: Biometria e contrato
      customer_data: Dados do cliente
      equipment: Equipamentos
      payment_model: Modelo de recebimento
      proposal: Proposta
      installation: Instalação
      concluded: Concluído
      expired: Expirado
      canceled: Cancelado
    error:
      fetching:
        title: Não conseguimos carregar os financiamentos
        description: Tente novamente mais tarde.
  ErrorEmptyState:
    title: Ops, algo deu errado
    subtitle: >-
      Ocorreu algum problema e não conseguimos trazer o resultado. Tente
      novamente mais tarde
unauthorized:
  title: Sem autorização de acesso
  description: >-
    Você não tem permissão para acessar essa página. Se você achar que isso é um
    erro, consulte o administrador da sua conta.
notFound:
  title: Página não encontrada
  description: >-
    A página que você está procurando não existe. Verifique o endereço digitado,
    ou volte para a listagem ou crie uma nova simulação.
unknonwError:
  title: Sem informações disponíveis
  description: >-
    Algo deu errado, tente novamente mais tarde. Se você achar que isso é um
    erro, consulte o administrador da sua conta.
noResults:
  title: Ops, algo deu errado
  description: >-
    Ocorreu algum problema e não conseguimos trazer o resultado da sua
    simulação. Tente novamente mais tarde
emptyStateRegister:
  title: Sem informações disponíveis
  subtitle: >-
    Ocorreu um problema ao obter informações sobre o financiamento. Tente
    recarregar a página.
formalization:
  upload:
    maximum_size:
      text: Tamanho máximo de
      10mb: 10MB
    accepted_files:
      text: por arquivo
      files: (JPEG, JPG, PNG e PDF)
      files_rg_cnh: (JPEG, JPG, PNG e PDF)
      files_cnh_digital: (PDF)
    cpf_attention:
      text: Atenção!
      description: Documentos devem conter o número do CPF
  client:
    title: Insira as informações e documentos do seu cliente solicitados abaixo
    cpf:
      label: CPF do(a) cliente
      placeholder: 000.000.000-00
      label_guarantor: CPF do(a) avalista
    name:
      label: Nome Completo do(a) cliente
      placeholder: Preencha o nome completo do cliente
      label_guarantor: Nome Completo do(a) avalista
      placeholder_guarantor: Preencha o nome completo do avalista
    address:
      label: Endereço do(a) cliente
    birthdate:
      label: Data de Nascimento do cliente
      placeholder: 00/00/0000
      label_guarantor: Data de Nascimento do avalista
    phone:
      label: Celular do(a) cliente
      placeholder: (00) 00000-0000
      label_guarantor: Celular do(a) avalista
    email:
      label: E-mail do(a) cliente
      placeholder: Insira o email do cliente
      label_guarantor: E-mail do(a) avalista
      placeholder_guarantor: Insira o email do avalista
  majority:
    address: Endereço residencial sócio majoritário
  customer_documents:
    documents: Documento
    document:
      example:
        link: Exemplo de envio
        title: Exemplo de como deve ser enviado
        image:
          front:
            alt: Exemplo de RG frente
            title: Frente do documento
          back:
            alt: Exemplo de RG verso
            title: Verso do documento
      type_front: Frente do RG* |  Frente da CNH*
      type_back: Verso do RG* |  Verso da CNH*
    digital_document: CNH Digital
  address:
    cep:
      label: CEP
      placeholder: 00000-000
    number:
      placeholder: '1234'
    installation:
      label: Endereço do local de instalação
    guarantor:
      label: Endereço do avalista
  legal_representant:
    documents:
      title: >-
        Documentação do representante legal | Documentação do 1º representante
        legal
      secundary: Documentação do 2º representante legal
    address:
      title: >-
        Endereço residencial representante legal | Endereço residencial 1º
        representante legal
      secundary: Endereço residencial 2º representante legal
  electricity_bill:
    title: Conta de luz do local da instalação
    info_bill: >-
      Envie a conta completa, em nome da pessoa física ou jurídica de até 90
      dias de emissão.
    info_files: >-
      Agilize sua análise! De preferência para arquivos em .pdf do site da
      concessionária. Tamanho máximo de 10MB por arquivo (JPEG, JPG, PNG e PDF)
    form:
      electricity_bill_customer_name: A conta de luz está no nome do seu cliente?
      proof_link_document: Comprovante de vínculo
      document_account_holder:
        label: CPF do titular da conta
        placeholder: Insira o CPF do titular da conta
    what_is_proof_of_link: O que é comprovante de vínculo?
    energy_concessionaire: Concessionária de energia
    concessionaire_placeholder: Selecione
    access_opinion:
      label_optional: Parecer de acesso (opcional)
      label_required: Parecer de acesso (obrigatório)
      optional_title: Este projeto pode precisar de Parecer de Acesso
      optional_description: >-
        Se a soma da potência dos inversores ultrapassar 7,5 kW, a {concessionaire} pode
        exigir o Parecer de Acesso (também conhecido como Orçamento Prévio), documento
        técnico que autoriza a conexão do sistema solar à rede elétrica. Essa verificação
        é responsabilidade do integrador. Se for o caso, anexe o documento abaixo.
      optional_title_fallback: Este projeto pode precisar de Parecer de Acesso
      optional_description_fallback: >-
        Se a soma da potência dos inversores ultrapassar 7,5 kW, a distribuidora de energia
        pode exigir o Parecer de Acesso (também conhecido como Orçamento Prévio), documento
        técnico que autoriza a conexão do sistema solar à rede elétrica. Essa verificação
        é responsabilidade do integrador. Se for o caso, anexe o documento abaixo.
      required_title: 'A {concessionaire} exige o Parecer de Acesso para este projeto'
      required_description: >-
        Também conhecido como Orçamento Prévio, o Parecer de Acesso é um documento técnico
        emitido pela distribuidora de energia que autoriza a conexão do sistema solar à
        rede elétrica. Solicite-o diretamente à {concessionaire} e anexe abaixo para continuar.
      required_title_fallback: A distribuidora de energia exige o Parecer de Acesso para este projeto
      required_description_fallback: >-
        Também conhecido como Orçamento Prévio, o Parecer de Acesso é um documento técnico
        emitido pela distribuidora de energia que autoriza a conexão do sistema solar à
        rede elétrica. Solicite-o diretamente à distribuidora de energia e anexe abaixo para
        continuar.
      required_error: Anexe o Parecer de Acesso para continuar.
      loading: Verificando a exigência do Parecer de Acesso
  other_beneficiary_units:
    question: Outras unidades serão beneficiadas/consumidoras desse projeto Solar?
  electricity_bills:
    additional_unit_bill: Conta de luz adicional da unidade
    form:
      electricity_bill_customer_name: A conta de luz está no nome do seu cliente?
      proof_link_document: Comprovante de vínculo
      document_account_holder:
        label: CPF do titular da conta
        placeholder: Insira o CPF do titular da conta
    what_is_proof_of_link: O que é comprovante de vínculo?
    bill_number: 'Unidade {number}'
    remove_bill: Remover unidade
    add_beneficiary_unit: + Adicionar outra unidade beneficiada/consumidora
    modal_what_is_bond:
      description:
        part_1: Documento que comprova o
        bond_degree: vínculo de 1º grau
        part_2: entre o
        holder: titular da conta de luz
        part_3: e o
        borrower: tomador do crédito
      cards:
        first:
          title: Filho(a), pai, mãe ou irmão(ã) como titular da conta de luz
          text_start: Anexe o
          emphasis: RG ou CNH (com CPF)
          text_end: ' do titular da conta.'
        second:
          title: Cônjuge ou companheiro(a) como titular da conta de luz
          text_start: Anexe
          emphasis: Certidão de Casamento ou de União Estável
          text_end: >-
            '. Os nomes do titular da conta e do tomador do crédito devem
            aparecer como partes no documento.'
      okay: Está bem, entendi!
price:
  modal:
    title: Atualização de preços e taxas
    primary: Entendi e quero continuar
    secondary: Não quero editar simulação
    body: >-
      Nossas taxas e preços sofreram alterações desde a última simulação que
      você realizou pra este projeto
    subbody: >-
      Sua simulação só será atualizada se você confirmar as edições realizadas.
      Caso contrário, você seguirá com o mesmo valor inicialmente registrado.
price-change:
  modal:
    title: Atenção!
    primary: Confirmar edição
    secondary: Cancelar
    body: >-
      Esta alteração irá atualizar os valores da sua simulação, descartando a
      condição anterior. Deseja continuar?
    primary-loading: Atualizando...
global:
  statuses:
    in_progress: Em andamento
    under_analysis: Em análise
    approved: Aprovado
    to_review: Revisar
    waiting_customer: Aguardando cliente
    reproved: Reprovado
    expired: Expirado
    canceled: Cancelado
toast:
  approved:
    documentation:
      title: Documentação aprovada
      description: >-
        Analisamos a documentação enviada e está tudo correto! Siga para próxima
        etapa.
  incomplete:
    documentation:
      title: Documentação incompleta
      description: Verifique se todos os campos estão preenchidos para envio da análise.
  sended:
    documentation:
      title: Documentação enviada
      description: Documentação enviada com sucesso!
  error:
    upload:
      title: Erro ao enviar arquivo
      description: >-
        Ocorreu um erro ao enviar o arquivo, verifique o tipo do arquivo ou o
        tamanho e tente novamente.
    send:
      title: Erro ao enviar
      description: >-
        Ocorreu um erro ao enviar o formulário. Verifique os campos e tente
        novamente.
    reproved:
      description: >-
        A documentação enviada não cumpre os requisitos exigidos. Faça uma nova
        simulação ou entre em contato conosco.
      title: Documentação reprovada
    edit:
      biometry:
        send:
          description: >-
            Infelizmente não conseguimos processar sua requisição neste momento.
            Por favor, tente novamente mais tarde!
  success:
    send:
      title: Documentação aprovada!
      description: >-
        Analisamos a documentação enviada e está tudo correto! Siga para a etapa
        de equipamentos.
  informative:
    send:
      under_analisys:
        title: Documentação em análise com especialista
        description: >-
          Nosso especialista está analisando a documentação enviada e retornará
          em até 24h.
lack-bank:
  modal:
    title: Você precisa ativar a sua conta de recebimento
    button: Solicitar ativação
    subtitle: >-
      Para darmos continuidade à análise e liberação do seu financiamento, é
      necessário ativar a sua conta de recebimento.
    whatsapp_description: >-
      Por favor, entre em contato conosco pelo Whatsapp:
    contact:
      title: Central de Atendimento
      whatsapp_number: 11 91238-6374
    activate_account:
      title: O que será solicitado para ativar?
      items:
        title_1: >-
          Seus <strong>dados bancários</strong> (banco, agência e conta) ou <strong>chave Pix</strong> (CNPJ ou e-mail).
        title_1_description: Os dados devem ser de uma conta de mesma titularidade do contrato.
        title_2: >-
          Em alguns casos, o <strong>Contrato Social atualizado</strong> e <strong>CNH ou RG</strong>
          dos sócios também poderão ser necessários.
    info_text: >-
      Regularize o mais breve possível e evite atrasos em seus projetos.
payment-model:
  modal-confirmation:
    send: Estou ciente e quero continuar
    cancel: Voltar para edição
    title: Atenção! Confira as opções selecionadas
    description-1: >-
      Após o envio das notas fiscais para análise, as opções selecionadas no
      Modelo de Recebimento
    description-2: >-
      Não deixe de conferir se está selecionada a melhor forma de recebimento
      para sua empresa! Você deseja continuar?
    description-alert: não poderão ser editadas
    equipment-warning: >-
      Após submeter o seu Modelo de Recebimento, não será mais possível alterar os equipamentos do seu projeto.
    vkit-warning: >-
      Parceiro integrador, o seu financiamento tem um valor menor que o kit contratado. Você precisará desembolsar o valor restante para a distribuidora.
receipt-model:
  load_error:
    not_found:
      action: Clique para recarregar
    unprocessable:
      title: Não foi possível carregar o modelo de recebimento
      subtitle: >-
        Ocorreu um imprevisto e não foi possível carregar o modelo de recebimento.
        Por favor, tente novamente.
      action: Tente novamente
  send-billing-letter:
    error:
      title: >-
        Carta de faturamento não enviada, favor verifique se os email estão
        corretos.
      description: Verifique os email selecionados e tente novamente.
    success:
      title: Carta de faturamento enviada!
      description: A carta de faturamento foi enviada para os emails adicionados.
  invoice:
    project_invoice_alert:
      title: Como deve ser a nota fiscal do projeto
      text: >-
        Emita uma única NF pelo <strong>valor total financiado</strong> —
        correspondente ao custo dos equipamentos somado ao valor dos serviços. O
        <strong>tomador</strong> deve ser o cliente final que está financiando o
        projeto (não a Solfácil).
  model_select:
    service:
      split: '{cash}% à vista + {installation}% após a aprovação da instalação'
      after_installation: 100% após aprovação da instalação
      in_cash: 100% à vista
      unknown: Conforme o modelo {code}
    column_model: Modelo
    column_supplier: Fornecedor do kit
    column_service: Serviço
    supplier_in_cash: À vista
    aria_label: 'Modelo de recebimento: {model} — {service}'
    listbox_label: Modelos de recebimento disponíveis
  supplier_select:
    label: Distribuidora*
    placeholder: Selecione...
    search_placeholder: Buscar distribuidora...
    search_label: Buscar distribuidora
    listbox_label: Distribuidoras
    group_partners: Distribuidoras parceiras
    group_others: Demais distribuidoras autorizadas
    no_results: Nenhum resultado encontrado
    loading: Carregando distribuidoras...
  email_tags:
    required: Adicione pelo menos um e-mail antes de enviar.
  receivables:
    title: Valores a receber
    details_title: Detalhes do financiamento
    groups:
      kit_invoice: Após aprovação da nota fiscal do kit
      receipt_approval: Após aprovação dos dados de recebimento
      installation: Após a conclusão da instalação
    transfer_title: Transferência {number}
    descriptions:
      services_installment: 'Serviços prestados {index}/{total} ({percent}%)'
      services_single: Parcela única, 100% do valor da NF
      commission_financing: Comissão do financiamento
      commission_insurance: Comissão de seguros
      kit_reimbursement: Reembolso da compra do kit
    status:
      analysis: Em análise
      pending: Pendente
      scheduled: Programada
      paid: Paga
      error: Erro
      cancelled: Cancelada
    in_analysis: Em análise
    view_receipt: Ver comprovante
    view_receipt_aria: 'Ver comprovante: {title}'
    total: Total a receber
    empty:
      title: Aguardando notas fiscais
      subtitle: Anexe e envie suas notas fiscais para verificação dos valores a receber.
    empty_confirm:
      title: Confirme para ver os valores
      subtitle: >-
        Os valores a receber aparecem aqui depois que você confirmar o modelo de
        recebimento.
    no_values:
      title: Sem valores a receber
      subtitle: Este projeto não possui valores pendentes de recebimento.
    details:
      financed_value: Valor total financiado
      equipment: Equipamentos
      kit: Kit da distribuidora {supplier}
      kit_reimbursable: Kit da distribuidora {supplier} (Reembolsável)
      kit_unnamed: Kit da distribuidora
      kit_reimbursable_unnamed: Kit da distribuidora (Reembolsável)
      my_services: Meus serviços
      my_commissions_and_services: Minhas comissões e serviços
      services: Serviços prestados
      commission_financing: Comissão do financiamento
      commission_insurance: Comissão de seguros
  layout:
    model_section:
      title: Modelo de recebimento
      helper: >-
        Você pode escolher entre os modelos de recebimento que estavam
        disponíveis para sua empresa no momento em que o contrato foi assinado.
    invoice_denied_alert:
      title: A nota fiscal enviada contém informações incorretas que impedem a análise
      fix_text: >-
        Para corrigir, verifique os dados da nota fiscal e emita uma
        {correctionLetter} no portal da SEFAZ do seu estado ou no sistema
        emissor da NF-e, sem precisar cancelar a nota.
      correction_letter: Carta de Correção Eletrônica (CC-e)
      attach_text: 'Após emitir, baixe o PDF, {attachLink} e envie para análise novamente.'
      attach_link: anexe no campo indicado abaixo
    invoice_divergent_alert:
      title: Nota fiscal com informações divergentes do projeto
      text: >-
        Verifique se as informações de descrição de kit, endereço, alienação e
        comprovantes estão preenchidas corretamente na nota fiscal enviada. Caso
        necessário, anexe uma carta de correção com as informações ajustadas de
        acordo com o projeto.
    approved_alert:
      title: >-
        Documentação aprovada! Acompanhe seus pagamentos em Valores a
        receber
      text: >-
        A documentação enviada foi aprovada por nossos especialistas. Em Valores
        a receber você acompanha o andamento das transferências e os pagamentos
        realizados pela Solfácil.
    resend_for_analysis: Reenviar para análise
    missing_payout_option: Selecione um modelo de recebimento antes de enviar.
  supplier_info:
    title: Sobre os equipamentos
    kit_value_label: Valor total do kit
    vkit_paid:
      title: Pagamento do kit realizado com sucesso.
      text: O pagamento foi realizado diretamente à distribuidora.
      downloading: Baixando comprovante...
    vkit_scheduled:
      title: Pagamento do kit programado.
      text: O pagamento será realizado diretamente à distribuidora.
    partner_alert:
      title: A parceria entre a Solfácil e a {name} gera vantagens para você.
      text: >-
        Por ser uma distribuidora parceira, você não precisará desembolsar o valor
        do kit e comprometer o seu fluxo de caixa. Nós validaremos o pedido e
        faremos o pagamento diretamente a ela.
    not_partner_alert:
      title: No caso desta distribuidora, você paga pelo kit e nós o reembolsamos
      text: >-
        Como esta distribuidora não possui faturamento direto com a Solfácil, o
        pagamento do kit precisa ser feito por você.
      text_complement: >-
        Após isso, anexe a nota fiscal de compra abaixo para que possamos realizar
        o seu reembolso.
  billing_letter:
    errors:
      invalid_email: Email inválido
      send_failed: Informe um email válido
    title: Carta de faturamento
    description: >-
      Documento gerado pela Solfácil para autorizar a distribuidora parceira a
      emitir a nota fiscal do kit financiado.
    description_complement: Informe abaixo os e-mails de contato da distribuidora para enviar.
    emails_label: E-mail(s) de contato da distribuidora {name}
    send: Enviar e-mails
    resend: Reenviar
    download: Fazer download da carta
    recipients: 'Para:'
    sent_alert:
      title: Carta de faturamento enviada.
      text: Se necessário, você pode reenviar a carta pelo botão abaixo.
    next_steps:
      title: 'Após enviar a carta de faturamento:'
      contact_before: 'Entre em contato com a distribuidora '
      contact_after: .
      informed_before: 'Informe que você já enviou a '
      informed_bold: carta de faturamento
      informed_after: ' da Solfácil.'
      request_before: 'Solicite a '
      request_bold: nota fiscal do kit
      request_after: .
      attach_bold: Anexe abaixo
      attach_after: ' a nota fiscal recebida.'
  invoices:
    errors:
      delete_failed: Arquivo não deletado, tente novamente!
    title: Notas fiscais
    products_label: Nota fiscal dos equipamentos*
    commission_label: Nota fiscal da comissão do financiamento*
    commission_hint: Utilize as informações abaixo para emitir sua nota fiscal.
    reminder:
      title: Lembre-se de enviar as informações para análise no final da página.
      title_to_review: Lembre-se de reenviar as informações para análise no final da página.
      text_single: A nota fiscal foi anexada. Agora, basta enviar e aguardar o retorno da análise.
      text_plural: As notas fiscais foram anexadas. Agora, basta enviar e aguardar o retorno da análise.
      text_to_review: Anexe a Carta de Correção, reenvie e aguarde o retorno da análise.
  commission_info:
    address_neighborhood: Bairro {neighborhood}
    address_zipcode: 'CEP: {zipcode}'
    title: Informações para emissão da nota fiscal de comissão
    value: Valor da nota
    cnpj: CNPJ
    corporate_name: Razão social
    municipal_registration: Inscrição Municipal (IM)
    main_activity: Atividade principal (CNAE)
    address: Endereço
    email: E-mail
result:
  tag:
    guarantor:
      pending: Necessita avalista
      approved: Avalista aprovado
      partially_approved: Aprovado parcial
      total_approved: Aprovado
  bnpl:
    reproved:
      description: Infelizmente, esta condição não está disponível para seu cliente.
    description_card: >-
      Adquira seu kit solar na Loja Solfácil, e ofereça essa nova condição como
      mais uma possibilidade de fechar negócios!
defaultDenialReason: Valide se o arquivo esta correto
accordion:
  date:
    completedAt: Concluído em
    orderChangedAt: Troca realizada em
    reprovedAt: Reprovado em
    submittedAt: Enviado em
    in_progress: (em andamento)
installation:
  inverter:
    credentials:
      server:
        divider: Servidor de localização das plantas
      app:
        divider: Dados 1˚ inversor
      password:
        helper: Senha utilizada  na {brandName}
        label: Senha
      login:
        helper: Usuário utilizado na {brandName}
        label: Usuário de instalador
      business-name:
        helper: Nome da empresa registrado na {brandName}
        label: Business Name
      solar-plant-name:
        label: Nome da planta do cliente
        helper: Preencha com o nome da planta cadastrado no monitoramento
    create:
      errors:
        PRECONDITION_FAILED:
          title: Erro de pré condição
          description: >-
            Não é possível combinar modos de entrada: os inversores atuais usam
            OCR, mas o novo é MANUAL
        DEFAULT:
          title: Algo deu errado
          description: Aconteceu um erro inesperado, por favor procure o suporte.
blocked_list:
  alert:
    title: >-
      Este usuário está bloqueado temporariamente para realizar novas
      simulações.
    description: Entre em contato com a Solfácil para regularizar seu cadastro.
    action: Regularizar cadastro
  whatsapp:
    message: Olá, eu gostaria de regularizar meu cadastro na Solfácil.
project:
  max_installments: Prazo
  shortage: Carência
  entry: Entrada
  down_payment: Entrada minima
  kit_acquisition: Aquisição kit
  solfacil_store: Loja Solfácil
  solfacil_store_or_external: Loja Solfácil ou externo
  solfacil_store_with_asterisk: Loja Solfácil*
reassessment:
  modal:
    title: Aprovamos novos clientes da sua carteira
    button: Ir para repescagem
    seeLater: Ver depois
    neverShowAgain: Não ver mais
    description:
      prefix: 'Com a '
      highlight: Repescagem Solfácil
      suffix: ' você não perde oportunidade de fazer negócio! Reanalisamos o crédito de clientes com projetos reprovados e aprovamos condições especiais para você.'
  alert:
    title: Novos clientes aprovados da sua carteira
    description: >-
      Com a Repescagem SolFácil você não perde oportunidade de fazer negócio!
      Reanalisamos o crédito de clientes com projetos reprovados e aprovamos
      condições especiais para você.
  notFound:
    title: Você não possui clientes aprovados na repescagem
    subtitle: >-
      Esse é um processo automático e você será avisado pela plataforma quando
      possuir um projeto reanalisado.
    emptyFilter: Tente ajustar os filtros para encontrar os projetos desejados
blocked:
  default_installation_delay_alert:
    title: >-
      Identificamos financiamentos não instalados e inadimplentes, e devido a
      isso seu acesso a novos financiamentos pode ser suspenso.
    description: >-
      Para evitar a suspensão, é necessário concluir as instalações pendentes
      ou orientar os clientes a regularizar a situação dos pagamentos em atraso.
    action: Ver instalações em aberto
  default_installation_delay_temporary:
    title: >-
      Identificamos financiamentos não instalados e inadimplentes, suspendendo
      temporariamente seu acesso a novos financiamentos.
    description: >-
      Para normalizar seu acesso, é necessário concluir as instalações pendentes
      ou orientar os clientes a regularizar a situação dos pagamentos em atraso.
    action: Ver instalações em aberto
  risk_buyback_alert:
    title: >-
      Identificamos financiamentos não instalados e inadimplentes, e devido a isso
      seu acesso a novos financiamentos pode ser suspenso.
    description: >-
      Para evitar a suspensão, é necessário concluir as instalações pendentes ou
      orientar os clientes a regularizar a situação dos pagamentos em atraso.
    action: Ver instalações em aberto
  risk_buyback_temporary:
    title: >-
      Identificamos financiamentos não instalados e inadimplentes, suspendendo
      temporariamente seu acesso a novos financiamentos.
    description: >-
      Para normalizar seu acesso, é necessário concluir as instalações pendentes
      ou orientar os clientes a regularizar a situação dos pagamentos em atraso.
    action: Ver instalações em aberto
  high_default_rate_alert:
    title: >-
      Seu acesso a novos financiamentos pode ser temporariamente bloqueado devido ao
      alto volume de inadimplência na sua carteira.
    description: >-
      Confira os clientes inadimplentes e os oriente a regularizar as parcelas
      vencidas para evitar possíveis bloqueios.
    action: Ver clientes pendentes
  high_default_rate_temporary:
    title: >-
      Seu acesso a novos financiamentos está temporariamente bloqueado devido ao
      alto volume de inadimplência na sua carteira.
    description: >-
      Confira os clientes inadimplentes e os oriente a regularizar as pendências
      para restabelecer seu acesso.
    action: Ver clientes pendentes
  preventive_temporary:
    title: >-
      Seu acesso a novos financiamentos está temporariamente bloqueado e está sob
      análise interna.
    description: >-
      Aguarde enquanto analisamos seu cadastro. Caso esse prazo já tenha
      passado, entre em contato com um gerente de contas através do telefone
      +55 (11) 91238-6374 ou diretamente via Whatsapp clicando ao lado.
    action: Falar com um gerente
  preventive_alert:
    title: Seu acesso a novos financiamentos pode ser bloqueado.
    description: >-
      Para entender os motivos e regularizar sua situação, entre em contato com um
      gerente de contas através do telefone +55 (11) 91238-6374 ou diretamente via
      WhatsApp clicando ao lado.
    action: Falar com um gerente
  pending_receipt_model_temporary:
    title: >-
      Seu acesso a novos financiamentos está temporariamente bloqueado, pois
      identificamos projetos com a etapa de modelo de recebimento em aberto há mais
      de 14 dias.
    description: >-
      Verifique os projetos em aberto e conclua essa etapa na plataforma para
      retomar suas simulações com a Solfácil.
    action: Regularizar projetos
  pending_receipt_model_alert:
    title: >-
      Seu acesso a novos financiamentos pode ser bloqueado!
    description: >-
      Identificamos projetos com a etapa de modelo de recebimento em aberto há mais de 7 dias.
      Conclua em até 6 dias para evitar bloqueio
      Verifique os projetos em aberto e conclua essa etapa agora mesmo
    action: Regularizar projetos
  limit_temporary:
    title: >-
      Você possui projetos ainda não instalados que comprometeram o seu limite
      de crédito atual, impedindo a realização de novos financiamentos
    description: >-
      Para retomar novas formalizações, é necessário concluir as instalações pendentes.
    action: Concluir instalações
  partner_inactive_temporary:
    title: >-
      Seu acesso a novos financiamentos está temporariamente bloqueado.
    description: >-
      Devido ao tempo maior que 90 dias sem realizar transações conosco, seu acesso
      foi temporariamente bloqueado. Para regularizar sua situação, entre em
      contato com seu gerente de contas através do telefone Whatsapp +55 (11) 91238-6374
    action: Falar com um gerente
  confirmed_fraud_definitive:
    title: >-
      Seu acesso a novos financiamentos está bloqueado em definitivo por políticas
      internas.
    description: ''
    action: ''
  blacklist_legal_webjud_definitive:
    title: >-
      Seu acesso a novos financiamentos está bloqueado em definitivo por políticas
      internas.
    description: ''
    action: ''
  partnership_termination_definitive:
    title: >-
      Seu acesso a novos financiamentos está bloqueado em definitivo por políticas
      internas.
    description: ''
    action: ''
  payment_block_bots_amr_alert:
    title: >-
      Atenção! Seu acesso pode ser suspenso.
    description: >-
      Existem valores a devolver de cancelamento(s) de clientes que já
      pagamos à você. Por favor entre em contato com nossa Central ou o seu GC
      para entender mais detalhes.
    action: Falar com um gerente
  solarinove_integration_alert:
    title: >-
      Atenção!
    description: >-
      Finalize o cadastro de sua empresa para habilitar a formalização dos
      projetos.
    action: Finalizar cadastro
  deteriorated_financial_health_temporary:
    title: >-
      Seu acesso a novos financiamentos está temporariamente bloqueado e está
      sob análise interna.
    description: >-
      Aguarde enquanto analisamos seu cadastro. Caso esse prazo já tenha
      passado, entre em contato com um gerente de contas através do telefone
      +55 (11) 91238-6374 ou diretamente via Whatsapp clicando ao lado.
    action: Falar com um gerente
  deteriorated_financial_health_alert:
    title: >-
      Seu acesso a novos financiamentos está temporariamente bloqueado e está
      sob análise interna.
    description: >-
      Aguarde enquanto analisamos seu cadastro. Caso esse prazo já tenha
      passado, entre em contato com um gerente de contas através do telefone
      +55 (11) 91238-6374 ou diretamente via Whatsapp clicando ao lado.
    action: Falar com um gerente
  missing_operational_agreement_temporary:
    title: >-
      Seu acesso a novos financiamentos está temporariamente bloqueado
    description: >-
      Para regularizar, o usuário administrador precisa assinar o Acordo
      Operacional na plataforma Solfácil.
    action: Falar com um gerente
  generic:
    title: >-
      Você possui algum bloqueio temporário!
    description: >-
      Entre em contato com um gerente de contas para regularizar sua situação.
      +55 (11) 91238-6374 ou diretamente via Whatsapp clicando ao lado.
    action: Falar com um gerente
biometry:
  loading:
    messages: >-
      Estamos quase lá, Aguarde enquanto processamos a biometria, isso pode
      demorar alguns segundos, Assim que estiver disponivel você poderá seguir
      com o financiamento
  button:
    try_again: Tente novamente
  notFound:
    title: Você não possui clientes aprovados na repescagem
    subtitle: >-
      Esse é um processo automático e você será avisado pela plataforma quando
      possuir um projeto reanalisado.
    emptyFilter: Tente ajustar os filtros para encontrar os projetos desejados
modal:
  multiAccountAutoConsumption:
    title: Autoconsumo remoto
    actionButton: Está bem, entendi!
    description: >-
      O autoconsumo remoto permite usar a energia gerada por uma usina solar em várias contas de luz,
      desde que todas estejam no mesmo CPF ou CNPJ. Essa modalidade é garantida pela Lei nº 14.300/2022,
      o Marco Legal da Geração Distribuída.
    attentionTitle: Atenção, Integrador
    attentionMessage: >-
      Antes de formalizar, oriente o cliente sobre as regras do autoconsumo remoto e a necessidade de
      concentrar as contas de luz no CPF/CNPJ gerador, para que todas as unidades sejam beneficiadas
      pela geração de energia.

onboarding:
  common:
    skip_all: Pular tudo
    previous: Anterior
    next: Próximo
    finish: Concluir
  layout:
    header:
      step1:
        title: Menu e Busca Inteligente
        description: Navegação aprimorada e busca por projetos sempre disponível, em qualquer página do Portal de Financiamentos.
      finish_home: Ver mais novidades
      finish_internal: Concluir
      step2:
        title: Busca inteligente
        description: Agora voce tem uma busca inteligente sempre fixa e acessível em qualquer página.
      step3:
        title: Menu de navegação
        description: Navegue entre as principais áreas usando o menu de abas.
  pages:
    overview:
      step1:
        title: Iniciar nova simulação
        description: Aqui você inicia simulações e contratações de financiamento rapidamente.
      step2:
        title: Painel de Projetos em Andamento
        description: >-
          Acompanhe a sua esteira de financiamentos, desde as simulações até as instalações.
          Ao clicar nos status, você vai direto para a lista filtrada daqueles projetos.
      step3:
        title: Vantagens e Ofertas
        description: Acesse benefícios exclusivos e ofertas especiais disponíveis para você e seus clientes.
      step4:
        title: Saúde da Carteira
        description: Acompanhe a saúde da sua carteira e mantenha o controle da inadimplência em dia.
      step5:
        title: Modelo de Recebimento
        description: Veja o seu modelo de recebimento atual e o seu desempenho. Para os detalhes, acesse a Minha carteira.
fileUpload:
  existingFile: Arquivo enviado
  loading: Carregando arquivo...
  replace: Substituir
  view: Visualizar
  download: Baixar
  emptyLabel: Clique para enviar ou arraste o arquivo
  helperText: '{exts} (máx. {maxSizeMb}MB)'
  errors:
    maxSize: O arquivo deve ter no máximo {maxSizeMb}MB.
    invalidFormat: 'Formato inválido. Aceitos: {formats}'
  preview:
    title: Prévia do PDF
    loadError: Não foi possível carregar o PDF
components:
  email_tags_input:
    placeholder: Digite o(s) e-mail(s)
    helper: >-
      Digite um e-mail e pressione vírgula ou ENTER para adicionar. Repita para
      incluir mais destinatários.
    invalid_email: Digite um e-mail válido.
    max_reached: 'Limite de {max} e-mails atingido. Remova um para adicionar outro.'
    remove_aria: Remover {email}
    list_aria: E-mails adicionados
my_wallet:
  title: Minha carteira
  tabs:
    aria: Abas de Minha carteira
    summary: Resumo
    receiving_model: Modelo de recebimento
  updated_at: 'Atualizado em {date} às {time}'
  list_and: '{items} e {last}'
  list_separator: ', '
  loading: Carregando informações da carteira
  not_impersonate:
    title: Consulte a carteira de um parceiro
    description: Para fazer isso, entre no modo de visualização como parceiro.
    button: Visualizar com parceiro
  error:
    title: Não foi possível carregar as informações
    description: Tivemos um problema para buscar os dados da sua carteira. Tente novamente em alguns instantes.
    retry: Recarregar
  forbidden:
    title: Você não tem acesso a estas informações
    description: Solicite ao administrador da sua conta o acesso à carteira da empresa.
  empty:
    title: Ainda não há informações da sua carteira
    description: Os dados aparecem aqui assim que forem processados. Volte mais tarde.
  block_error:
    title: Não foi possível carregar esta informação.
    retry: Recarregar
  status_banner:
    contact: fale conosco
    enabled:
      title: Habilitado para novos financiamentos
      description: Tudo certo para financiar novos projetos. Continue mantendo os indicadores de saúde da carteira em dia.
      description_starting: Você está começando. Seus indicadores serão calculados à medida que você avançar com seus projetos.
    warning:
      title: Fique atento para não ser bloqueado
      description: 'Você possui um ou mais indicadores {highlight} que precisam de atenção.'
      highlight: em alerta
    blocked:
      title: Bloqueado para novos financiamentos
      description: 'Há itens em {highlight} na sua carteira que precisam ser resolvidos.'
      highlight: nível crítico
    blocked_policy:
      title: Conta bloqueada por desacordo de políticas internas.
      description: 'Novos financiamentos, modelos de recebimento e limite de crédito estão indisponíveis. Para mais informações, {contact}.'
    blocked_financial_health:
      title: O financiamento de novos projetos não está disponível para sua empresa.
      description: 'Após análise da saúde financeira da sua empresa, o financiamento de novos projetos precisou ser bloqueado por tempo indeterminado{br}Para mais informações, {contact}.'
  no_completions:
    value: Sem desempenho a avaliar
    caption: 'nos últimos {days} dias'
    title: 'Você não concluiu nenhuma instalação nos últimos {days} dias.'
    description: 'Para escolher o seu modelo, olhamos as instalações concluídas nesse tempo. Sem nenhuma, você recebe pelo Modelo {model}.'
  models:
    tag: 'MODELO {model}'
    split: '{upfront}% / {after}%'
    split_caption: No começo / No final
    titles:
      C: 'Recebe tudo{br}no final'
      B: 'Metade no começo,{br}metade no final'
      A: 'Recebe quase tudo{br}no começo'
    chips:
      DEFAULT: Padrão
      ENABLED: Habilitado
      DISABLED: Desabilitado
      BLOCKED: Bloqueado
      WAIVED: Flexibilização comercial
      LOCKED: Modelo ainda não alcançado
  receiving_model:
    title: Modelo de recebimento
    how_it_works: Como funciona?
    see_performance: Ver meu desempenho
    cards_aria: Modelos de recebimento
    essential_banner:
      alt: Concentre suas compras e financiamentos na Solfácil. Quanto mais projetos concluídos, mais vantagens você tem.
    carousel:
      go_to: 'Ir para o card {index} de {total}'
    commercial_exception_banner:
      title: Flexibilização comercial ativa.
      description: Você pode usar todos os modelos de recebimento.
    delinquency_banner:
      text: 'O Modelo {model} está desabilitado porque a {highlight} está em alerta.'
      highlight: inadimplência da sua carteira
    card:
      requirements_label: O que você precisa
      for_whom_label: Para quem é
      steps_waived_note: Você não precisa cumprir os itens abaixo. A Solfácil liberou este modelo para a sua empresa.
      conditions:
        REGISTRATION_ENABLED:
          requirement:
            text: 'Ter o {highlight} para financiar.'
            highlight: cadastro habilitado
          for_whom:
            text: 'Todo integrador com {highlight} pode usar.'
            highlight: cadastro habilitado
        FIRST_INSTALLATIONS_MANDATORY:
          text: 'Suas {highlight} sempre recebem por este modelo.'
          highlight: '{value} primeiras instalações'
        ONLY_MODEL_BELOW_THRESHOLD:
          text: 'Ter {highlight} nos últimos {days} dias.'
          highlight: 'menos de {value}% de instalações concluídas no prazo'
        fallback: Condição do modelo padrão.
      essential_condition:
        text: 'Empresas no {highlight} só podem usar este modelo.'
        highlight: Perfil Essencial
      novice_next:
        text: 'Depois delas, vamos ver se você {highlight} {onTime}.'
        highlight: conclui as instalações
        on_time: no prazo
      requirements:
        REGISTRATION_ENABLED_FOR_FINANCING:
          text: 'Ter o {highlight} para financiar.'
          highlight: cadastro habilitado
        MIN_COMPLETED_INSTALLATIONS:
          text: 'Ter {highlight} concluídas e aprovadas na carteira.'
          highlight: mais de 5 instalações
        DELINQUENCY_UNDER_CONTROL:
          text: 'Manter {highlight} sob controle.'
          highlight: níveis de inadimplência
        ON_TIME_PERCENTAGE_RANGE:
          label: 'Instalações concluídas nos últimos {days} dias:'
          text: '{range} {onTime}'
          on_time: no prazo.
          ranges:
            B: Entre 50% e 89%
            A: Acima de 90%
        fallback: Requisito do modelo.
      requirement_status_label: '{status}:'
      requirement_status:
        done: Cumprido
        pending: Pendente
        alert: Em alerta
        waived: Não se aplica
      milestone_status: 'Você já fez: {status}'
      milestone_value: '{completed} de {total}'
      current_performance: 'Atualmente você tem: {value}'
      performance_value: '{percentage}% no prazo'
      performance_link_context: '(Modelo {model}, ver em Meu desempenho)'
      not_evaluated: ainda não medido
      unavailable: Indisponível
    performance:
      title: Meu desempenho
      subtitle: Quanto mais instalações você concluir no prazo, melhor fica o seu jeito de receber.
      not_evaluated_banner:
        title: Agora, os seus prazos não contam.
        description: Mesmo assim, veja abaixo qual modelo você teria sem a flexibilização comercial.
      total_label: Total
      total_value: '{count} instalação concluída | {count} instalações concluídas'
      total_caption: 'nos {window}'
      window: 'últimos {days} dias'
      current_label: Desempenho atual
      current_value: '{percentage}% no prazo'
      enables_one: 'Habilita somente o Modelo {models}'
      enables_many: 'Habilita os Modelos {models}'
      enables_none: '-'
      enabled_models: '{models}.'
      requires_delinquency_mark: '{model}*'
      challenge_label: Sua meta
      challenge_value: 'Concluir mais {count} no prazo'
      challenge_caption: 'para chegar ao Modelo {model}.'
      keep_value: '*Mantenha a inadimplência sob controle'
      keep_caption: para continuar no Modelo A.
      commercial_label: Flexibilização comercial
      commercial_value: 'Modelo {models} também está habilitado | Modelos {models} também estão habilitados'
      commercial_caption: A equipe comercial da Solfácil liberou para você
      blocked_title: Todos os modelos estão desabilitados
      blocked_reason: 'Motivo: sua empresa não pode fazer novos financiamentos'
      disabled_title: 'Modelo {model} desabilitado'
      disabled_reason: 'Motivo: {reason}'
      disabled_reasons:
        DELINQUENCY_WARNING: inadimplência da carteira em alerta
        fallback: um requisito do modelo entrou em alerta
      bar:
        label: 'MODELO {model}'
        locked: bloqueado
        waived: liberado por flexibilização comercial
        mark: '{value}%'
        aria: '{percentage}% das instalações concluídas no prazo nos últimos {days} dias'
        aria_not_evaluated: Desempenho ainda não medido
        aria_with_states: '{summary}. {states}.'
        state_aria: 'Modelo {model} {state}'
    novice:
      subtitle: Para poder usar os Modelos A e B, primeiro conclua as suas 5 primeiras instalações.
      subtitle_done: Você concluiu as 5 primeiras instalações. Da 6ª em diante, vamos ver se você conclui no prazo.
      progress_label: Primeiras instalações
      progress_value: '{completed} de {total} feitas'
      challenge_label: Sua meta
      challenge_label_done: Sua próxima meta
      challenge_value: 'Concluir as {total} primeiras instalações'
      challenge_value_done: Concluir mais 1 instalação para começar a contar o prazo
      alert_title: As 5 primeiras instalações recebem pelo Modelo C.
      alert_description: Da 6ª em diante, vamos ver se você conclui no prazo. Assim, você pode passar para um modelo melhor.
      stepper_aria: '{completed} de {total} primeiras instalações feitas'
    completion:
      tabs_aria: Instalações concluídas no prazo e fora do prazo
      tabs:
        on_time: No prazo
        late: Fora do prazo
      on_time:
        title: Instalações concluídas no prazo
        description: Você concluiu estas instalações no prazo. Elas ajudam você a ter um modelo melhor.
        status: no prazo
        kit_prefix: concluídas em
        sla: 'até {days} dias'
      late:
        title: Instalações concluídas fora do prazo
        description: Você concluiu estas instalações depois do prazo. Elas baixam o seu resultado.
        status: fora do prazo
        kit_prefix: concluídas em
        sla: 'mais de {days} dias'
      count: '{count} de {total} instalações'
      caption: 'concluídas {status}'
      caption_window: 'nos últimos {days} dias'
      see_projects: Ver instalações
      kits:
        SOLFACIL_COMBO: COMBOS SOLFÁCIL
        OTHER_DISTRIBUTOR: KITS DE OUTRAS EMPRESAS
      kit_count: '{count} instalação | {count} instalações'
      counted_from:
        SOLFACIL_COMBO: depois que o kit chegou
        OTHER_DISTRIBUTOR: depois de assinar o contrato
      combo_banner:
        title: Com o Combo Solfácil é mais fácil!
        text: 'O prazo só começa quando o kit chega. Você tem {highlight} e ter os melhores modelos.'
        highlight: '{days} dias para concluir a instalação'
      gauge_aria:
        on_time: '{count} de {total} instalações concluídas no prazo'
        late: '{count} de {total} instalações concluídas fora do prazo'
  summary:
    title: Resumo da minha carteira
    card:
      title: Modelo de recebimento
      best_model: Seu melhor modelo atual
      model_button_prefix: 'Ver detalhes do Modelo {model}:'
      performance_label: Desempenho atual
      performance_value: '{percentage}% das instalações foram concluídas no prazo'
      performance_caption: 'nos últimos {days} dias'
      novice_label: Primeiras instalações
      novice_value: '{completed} de {total} feitas'
      novice_alert_title: Conclua as 5 primeiras instalações
      novice_alert_title_done: Conclua mais 1 instalação
      novice_alert_description: Da 6ª em diante, vamos ver se você conclui no prazo. Assim, você pode passar para um modelo melhor.
      commercial_title: Flexibilização comercial ativa.
      commercial_description: Você pode usar todos os modelos de recebimento.
      disabled_title: 'O Modelo {model} está desabilitado'
      disabled_reason: 'Motivo: {reason}'
      keep:
        text: '{highlight} para continuar no Modelo A.'
        highlight: Mantenha a inadimplência sob controle
      next:
        text: '{highlight} para chegar ao Modelo {model}.'
        highlight: 'Conclua mais {count} instalação no prazo | Conclua mais {count} instalações no prazo'
      blocked_title: Todos os modelos estão desabilitados
      blocked_description: Você ainda pode ver o seu desempenho.
      see_details: Ver detalhes
  faq:
    title: Dúvidas sobre os modelos de recebimento
    search_placeholder: Buscar nas perguntas frequentes
    clear: Limpar
    results: 'Mostrando {shown} de {total} perguntas.'
    show_all: Mostrar todas
    empty_title: Nenhuma pergunta encontrada
    empty_text: Tente outras palavras ou limpe a busca para ver todas as perguntas.
    items:
      what_are_models:
        question: O que é modelo de recebimento?
        answer:
          - paragraph: 'É o jeito que você recebe o dinheiro de um projeto financiado. São 3 modelos:'
          - bullets:
              - '**Modelo C**: você recebe tudo (100%) no final da instalação.'
              - '**Modelo B**: você recebe metade (50%) no começo e metade (50%) no final.'
              - '**Modelo A**: você recebe quase tudo (90%) no começo e o resto (10%) no final.'
      everyone_starts_at_c:
        question: Todo integrador começa no Modelo C?
        answer:
          - paragraph: Sim. O Modelo C é o modelo padrão. Todo integrador com cadastro habilitado começa nele. As 5 primeiras instalações sempre recebem pelo Modelo C, mesmo se você concluir todas no prazo.
      how_to_be_eligible_ab:
        question: Como faço para usar os Modelos A e B?
        answer:
          - numbered:
              - Conclua as suas 5 primeiras instalações.
              - Conclua mais 1 instalação. Da 6ª em diante, a Solfácil começa a ver se você conclui no prazo.
              - Quanto mais instalações no prazo, melhor o seu modelo.
      how_is_percentage_calculated:
        question: Como vocês fazem a conta do prazo?
        answer:
          - paragraph: 'Olhamos as instalações que você concluiu nos **últimos 90 dias** (uns 3 meses). Depois, vemos quantas foram concluídas **no prazo**. Todo dia, um dia novo entra na conta e o dia mais antigo sai. O prazo muda conforme o kit:'
          - bullets:
              - '**Combo Solfácil**: até 45 dias depois que o kit chega.'
              - '**Kit de outra empresa**: até 45 dias depois de assinar o contrato de financiamento.'
      model_ranges:
        question: Quanto preciso ter no prazo para cada modelo?
        answer:
          - bullets:
              - 'Menos de 50% no prazo → **Modelo C**'
              - 'Entre 50% e 89% no prazo → **Modelo B**'
              - '90% ou mais no prazo → **Modelo A**. O Modelo A também pede a inadimplência sob controle (veja a próxima pergunta).'
      why_only_a_requires_delinquency:
        question: Por que só o Modelo A pede a inadimplência sob controle?
        answer:
          - paragraph: No Modelo A, a Solfácil paga quase tudo (90%) logo no começo. Isso é um risco maior. Por isso, o Modelo A também pede que a inadimplência da sua carteira esteja sob controle. Os Modelos B e C não pedem isso.
      can_i_lose_model:
        question: Posso perder um modelo que já tenho?
        answer:
          - paragraph: Sim. A conta olha sempre os últimos 90 dias. Se você atrasar mais instalações, pode cair de modelo. No Modelo A, você também pode cair se a inadimplência da sua carteira piorar.
      when_is_performance_evaluated:
        question: Quando o meu prazo começa a contar?
        answer:
          - paragraph: 'Na 6ª instalação concluída. As 5 primeiras recebem pelo Modelo C e não entram na conta do prazo. Enquanto isso, a tela mostra "Ainda não medido".'
      why_still_model_c:
        question: Concluí as 5 primeiras. Por que ainda estou no Modelo C?
        answer:
          - paragraph: Concluir as 5 primeiras não muda o seu modelo sozinho. Elas só liberam o começo da conta. A conta começa na 6ª instalação concluída. Até lá, você continua no Modelo C.
      delinquency_warning:
        question: O que acontece se a inadimplência da minha carteira ficar em alerta?
        answer:
          - paragraph: O Modelo A fica desabilitado, mesmo se você concluir as instalações no prazo. Os Modelos B e C continuam normais. Quando a inadimplência voltar a ficar sob controle, o Modelo A volta sozinho. Você não precisa pedir.
      delinquency_critical:
        question: E se a inadimplência ficar em nível crítico?
        answer:
          - paragraph: Aí a sua empresa fica bloqueada para novos financiamentos. Todos os modelos ficam desabilitados, até o Modelo C. Isso também acontece em outros casos, como fraude, muitas instalações atrasadas ou pendências. O bloqueio só sai quando tudo for resolvido.
      why_all_blocked:
        question: Por que todos os meus modelos estão bloqueados?
        answer:
          - paragraph: 'Porque a sua empresa está bloqueada para novos financiamentos. Alguns motivos:'
          - bullets:
              - Inadimplência em nível crítico.
              - Muitas instalações com atraso grande.
              - Documentos ou contratos com pendência.
              - Decisão da Solfácil depois de uma análise.
          - paragraph: Enquanto isso, nenhum modelo fica habilitado. Fale com o suporte da Solfácil para saber mais.
      essential_profile_models:
        question: Quais modelos o Perfil Essencial pode usar?
        answer:
          - paragraph: Só o Modelo C, que é o padrão. Você recebe tudo (100%) no final da instalação.
      what_is_commercial_exception:
        question: O que é a flexibilização comercial?
        answer:
          - paragraph: É uma condição especial dada pela equipe comercial da Solfácil. Ela habilita todos os modelos para a sua empresa, mesmo que os seus prazos ainda não sejam suficientes. Quando ela acabar, o seu modelo volta a depender dos seus prazos.
      what_counts_as_on_time:
        question: Qual é o prazo para concluir a instalação?
        answer:
          - paragraph: 'Depende do kit:'
          - bullets:
              - '**Combo Solfácil**: até 45 dias depois que o kit chega.'
              - '**Kit de outra empresa**: até 45 dias depois de assinar o contrato de financiamento.'
          - paragraph: Todos os dias contam, inclusive sábado, domingo e feriado.
      why_different_deadlines:
        question: Por que o prazo do Combo Solfácil é diferente do kit de outra empresa?
        answer:
          - paragraph: No Combo Solfácil, o prazo começa quando o kit chega. O material já está com você. No kit de outra empresa, o prazo começa quando você assina o contrato. Depois disso, ainda é preciso comprar o material e esperar ele chegar. Por isso, o prazo é maior.
      do_kits_count_together:
        question: Instalações com Combo Solfácil e com kit de outra empresa contam juntas?
        answer:
          - paragraph: 'Sim, contam juntas. A conta usa todas as instalações concluídas nos últimos 90 dias. Na parte "Meu desempenho", você vê cada tipo separado.'
      data_update_frequency:
        question: Quando os números são atualizados?
        answer:
          - paragraph: Uma vez por dia. Os números mostram o que aconteceu até o dia anterior. A data e a hora da última atualização ficam no topo da tela.
